import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Draggable from 'react-draggable';
import html2canvas from 'html2canvas';
import './ShurikenDesigner.css';
import shurikenLogo from '../images/shuriken/logo.png';

// Google Fonts リスト（無料で利用可能な日本語フォント）
const GOOGLE_FONTS = [
  // ゴシック系
  { name: 'Noto Sans JP', value: "'Noto Sans JP', sans-serif", category: 'ゴシック' },
  { name: 'M PLUS 1p', value: "'M PLUS 1p', sans-serif", category: 'ゴシック' },
  { name: 'M PLUS Rounded 1c', value: "'M PLUS Rounded 1c', sans-serif", category: 'ゴシック' },
  { name: 'M PLUS 1', value: "'M PLUS 1', sans-serif", category: 'ゴシック' },
  { name: 'M PLUS 2', value: "'M PLUS 2', sans-serif", category: 'ゴシック' },
  { name: 'M PLUS 1 Code', value: "'M PLUS 1 Code', monospace", category: 'ゴシック' },
  { name: 'Kosugi', value: "'Kosugi', sans-serif", category: 'ゴシック' },
  { name: 'Kosugi Maru', value: "'Kosugi Maru', sans-serif", category: '丸ゴシック' },
  { name: 'Sawarabi Gothic', value: "'Sawarabi Gothic', sans-serif", category: 'ゴシック' },
  { name: 'Zen Kaku Gothic New', value: "'Zen Kaku Gothic New', sans-serif", category: 'ゴシック' },
  { name: 'Zen Kaku Gothic Antique', value: "'Zen Kaku Gothic Antique', sans-serif", category: 'ゴシック' },
  { name: 'Zen Maru Gothic', value: "'Zen Maru Gothic', sans-serif", category: '丸ゴシック' },
  { name: 'Murecho', value: "'Murecho', sans-serif", category: 'ゴシック' },
  { name: 'BIZ UDGothic', value: "'BIZ UDGothic', sans-serif", category: 'ゴシック' },
  { name: 'BIZ UDPGothic', value: "'BIZ UDPGothic', sans-serif", category: 'ゴシック' },
  { name: 'IBM Plex Sans JP', value: "'IBM Plex Sans JP', sans-serif", category: 'ゴシック' },
  { name: 'Kiwi Maru', value: "'Kiwi Maru', serif", category: '丸ゴシック' },
  { name: 'Kiwi Maru Light', value: "'Kiwi Maru', serif", category: '丸ゴシック' },
  // デザイン系
  { name: 'Reggae One', value: "'Reggae One', cursive", category: 'デザイン' },
  { name: 'RocknRoll One', value: "'RocknRoll One', sans-serif", category: 'デザイン' },
  { name: 'Stick', value: "'Stick', sans-serif", category: 'デザイン' },
  { name: 'DotGothic16', value: "'DotGothic16', sans-serif", category: 'デザイン' },
  { name: 'Rampart One', value: "'Rampart One', cursive", category: 'デザイン' },
  { name: 'Train One', value: "'Train One', cursive", category: 'デザイン' },
  { name: 'Dela Gothic One', value: "'Dela Gothic One', cursive", category: 'デザイン' },
  { name: 'Cherry Bomb One', value: "'Cherry Bomb One', cursive", category: 'デザイン' },
  { name: 'Slackside One', value: "'Slackside One', cursive", category: 'デザイン' },
  { name: 'Darumadrop One', value: "'Darumadrop One', cursive", category: 'デザイン' },
  // 明朝系
  { name: 'Noto Serif JP', value: "'Noto Serif JP', serif", category: '明朝' },
  { name: 'Sawarabi Mincho', value: "'Sawarabi Mincho', serif", category: '明朝' },
  { name: 'Shippori Mincho', value: "'Shippori Mincho', serif", category: '明朝' },
  { name: 'Shippori Mincho B1', value: "'Shippori Mincho B1', serif", category: '明朝' },
  { name: 'Shippori Antique', value: "'Shippori Antique', serif", category: '明朝' },
  { name: 'Shippori Antique B1', value: "'Shippori Antique B1', serif", category: '明朝' },
  { name: 'Zen Old Mincho', value: "'Zen Old Mincho', serif", category: '明朝' },
  { name: 'Zen Antique', value: "'Zen Antique', serif", category: '明朝' },
  { name: 'Zen Antique Soft', value: "'Zen Antique Soft', serif", category: '明朝' },
  { name: 'BIZ UDMincho', value: "'BIZ UDMincho', serif", category: '明朝' },
  { name: 'BIZ UDPMincho', value: "'BIZ UDPMincho', serif", category: '明朝' },
  { name: 'Hina Mincho', value: "'Hina Mincho', serif", category: '明朝' },
  { name: 'New Tegomin', value: "'New Tegomin', serif", category: '明朝' },
  { name: 'Kaisei Tokumin', value: "'Kaisei Tokumin', serif", category: '明朝' },
  { name: 'Kaisei Opti', value: "'Kaisei Opti', serif", category: '明朝' },
  { name: 'Kaisei HarunoUmi', value: "'Kaisei HarunoUmi', serif", category: '明朝' },
  // 筆記・行書系
  { name: 'Yuji Syuku', value: "'Yuji Syuku', serif", category: '行書' },
  { name: 'Yuji Mai', value: "'Yuji Mai', serif", category: '行書' },
  { name: 'Yuji Boku', value: "'Yuji Boku', serif", category: '行書' },
  { name: 'Zen Kurenaido', value: "'Zen Kurenaido', serif", category: '行書' },
  { name: 'Kaisei Decol', value: "'Kaisei Decol', serif", category: '行書' },
  // 手書き系
  { name: 'Yomogi', value: "'Yomogi', cursive", category: '手書き' },
  { name: 'Klee One', value: "'Klee One', cursive", category: '手書き' },
  { name: 'Komorebi Gothic', value: "'Komorebi Gothic', sans-serif", category: '手書き' },
  // ポップ系
  { name: 'Mochiy Pop One', value: "'Mochiy Pop One', sans-serif", category: 'ポップ' },
  { name: 'Mochiy Pop P One', value: "'Mochiy Pop P One', sans-serif", category: 'ポップ' },
  { name: 'Potta One', value: "'Potta One', cursive", category: 'ポップ' },
  { name: 'Hachi Maru Pop', value: "'Hachi Maru Pop', cursive", category: 'ポップ' },
  { name: 'Palette Mosaic', value: "'Palette Mosaic', cursive", category: 'ポップ' },
  { name: 'Otomanopee One', value: "'Otomanopee One', sans-serif", category: 'ポップ' },
  // 追加フォント
  { name: 'Zen Dots', value: "'Zen Dots', display", category: 'デザイン' },
  { name: 'Monomaniac One', value: "'Monomaniac One', sans-serif", category: 'デザイン' },
  { name: 'Rock 3D', value: "'Rock 3D', display", category: 'デザイン' },
  { name: 'Tsukimi Rounded', value: "'Tsukimi Rounded', sans-serif", category: '丸ゴシック' },
  { name: 'Yusei Magic', value: "'Yusei Magic', sans-serif", category: '手書き' },
  { name: 'Zen Tokyo Zoo', value: "'Zen Tokyo Zoo', display", category: 'デザイン' },
  { name: 'Chokokutai', value: "'Chokokutai', display", category: 'デザイン' },
  { name: 'Honk', value: "'Honk', display", category: 'デザイン' },
];

// デフォルトデータ（printTypeを各面に持たせる）
const getDefaultSideData = (isBlackCard = false) => ({
  printType: isBlackCard ? 'white' : 'none', // 黒カード: white, 白カード: none(カラー)
  templateImage: null,
  templateScale: 100,
  templatePosition: { x: 0, y: 0 }, // 背景画像の位置
  logoImage: null,
  logoScale: 100,
  logoPosition: { x: 10, y: 10 },
  logo2Image: null,
  logo2Scale: 100,
  logo2Position: { x: 280, y: 10 },
  textPositions: {
    company: { x: 15, y: 15 },
    position: { x: 15, y: 35 },
    nameKana: { x: 15, y: 70 },
    name: { x: 15, y: 85 },
    phone: { x: 15, y: 140 },
    email: { x: 15, y: 158 },
    address: { x: 15, y: 176 },
    website: { x: 15, y: 194 },
    freeText: { x: 15, y: 220 },
  },
  formData: {
    name: { text: '', color: '#000000', fontSize: 60, visible: true, vertical: false },
    nameKana: { text: '', color: '#333333', fontSize: 30, visible: true, vertical: false },
    company: { text: '', color: '#000000', fontSize: 36, visible: true, vertical: false },
    position: { text: '', color: '#333333', fontSize: 30, visible: true, vertical: false },
    phone: { text: '', color: '#222222', fontSize: 27, visible: true, vertical: false },
    email: { text: '', color: '#222222', fontSize: 27, visible: true, vertical: false },
    address: { text: '', color: '#222222', fontSize: 24, visible: true, vertical: false },
    website: { text: '', color: '#222222', fontSize: 24, visible: true, vertical: false },
    freeText: { text: '', color: '#222222', fontSize: 20, visible: true, vertical: false },
  },
  // ロック状態
  locks: {
    template: false,
    logo: false,
    logo2: false,
    company: false,
    position: false,
    nameKana: false,
    name: false,
    phone: false,
    email: false,
    address: false,
    website: false,
    freeText: false,
  },
});

const STORAGE_KEY = 'shuriken-designer-data';
const SCROLL_POSITION_KEY = 'shuriken-designer-scroll';

const ShurikenDesigner = () => {
  const previewRef = useRef(null);
  const isInitialLoad = useRef(true);

  // 金銀切り替え時の再マウント用カウンター
  const [metallicRenderKey, setMetallicRenderKey] = useState(0);

  // デザインモード（free: 自由デザイン / template: テンプレート）
  const [designMode, setDesignMode] = useState('free');
  // 選択中のテンプレート（複数選択可能）
  const [selectedTemplates, setSelectedTemplates] = useState([]);

  // 表裏切り替え（front/back）
  const [cardSide, setCardSide] = useState('front');

  // カード色（white/black）- 両面共通
  const [cardColor, setCardColor] = useState('white');
  // カードの向き（horizontal/vertical）- 両面共通
  const [cardOrientation, setCardOrientation] = useState('horizontal');

  // カードサイズ（向きによって変わる）- 名刺サイズ 85mm × 54mm 比率
  const cardWidth = cardOrientation === 'horizontal' ? 1012 : 643;
  const cardHeight = cardOrientation === 'horizontal' ? 643 : 1012;

  // グローバルフォント設定 - 両面共通
  const [globalFont, setGlobalFont] = useState(GOOGLE_FONTS[0].value);

  // 表面・裏面データを別々に保持（printTypeは各面に含まれる）
  const [frontData, setFrontData] = useState(getDefaultSideData(false));
  const [backData, setBackData] = useState(getDefaultSideData(false));

  // 現在の面のデータを取得
  const currentData = cardSide === 'front' ? frontData : backData;
  const setCurrentData = cardSide === 'front' ? setFrontData : setBackData;

  // 印刷タイプ（各面から取得）
  const printType = currentData.printType;
  const frontPrintType = frontData.printType;

  // プレビューズーム - UI用（80で実際の40%サイズ表示）
  const [previewZoom, setPreviewZoom] = useState(80);

  // 微調整モード用
  const [fineAdjustMode, setFineAdjustMode] = useState(false);
  const [selectedElement, setSelectedElement] = useState(null); // 'template', 'logo', 'logo2', 'company', etc.
  const [adjustStep, setAdjustStep] = useState(5); // 移動幅（px）
  const [showGrid, setShowGrid] = useState(false); // グリッド表示

  // ページローディング
  const [isPageLoading, setIsPageLoading] = useState(true);

  // 画像キャプチャ用
  const [captureMode, setCaptureMode] = useState(null); // null, 'preview', 'print'
  const [capturedImages, setCapturedImages] = useState(null);
  const [showCaptureModal, setShowCaptureModal] = useState(false);
  const [isCapturing, setIsCapturing] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showOrderConfirm, setShowOrderConfirm] = useState(false);

  // お客様情報入力用
  const [customerName, setCustomerName] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');

  // 確認モーダル用の表示面
  const [modalPreviewSide, setModalPreviewSide] = useState('front');

  // 送信完了モーダル
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // GAS WebアプリのURL（設定が必要）
  const GAS_WEBAPP_URL = process.env.REACT_APP_GAS_WEBAPP_URL || '';

  const [fontDropdownOpen, setFontDropdownOpen] = useState(false);
  const fontDropdownRef = useRef(null);
  const frontPreviewRef = useRef(null);
  const backPreviewRef = useRef(null);

  // 現在のデータから展開（便利なエイリアス）
  const templateImage = currentData.templateImage;
  const templateScale = currentData.templateScale ?? 100;
  const templatePosition = currentData.templatePosition || { x: 0, y: 0 };
  const logoImage = currentData.logoImage;
  const logoScale = currentData.logoScale ?? 100;
  const logoPosition = currentData.logoPosition || { x: 10, y: 10 };
  const logo2Image = currentData.logo2Image;
  const logo2Scale = currentData.logo2Scale ?? 100;
  const logo2Position = currentData.logo2Position || { x: 280, y: 10 };

  const textPositions = currentData.textPositions;
  const formData = currentData.formData;
  const locks = currentData.locks || {};

  // 裏面で選択可能な印刷タイプを取得
  const getAvailableBackPrintTypes = () => {
    if (cardColor === 'white') {
      // 白カード: 表面がnone(カラー)なら裏面もnoneのみ、金銀なら全選択可
      if (frontPrintType === 'none') {
        return ['none'];
      }
      return ['none', 'gold', 'silver'];
    } else {
      // 黒カード: 表面がwhiteなら裏面もwhiteのみ、金銀なら全選択可
      if (frontPrintType === 'white') {
        return ['white'];
      }
      return ['white', 'gold', 'silver'];
    }
  };

  // 表面で選択可能な印刷タイプを取得
  const getAvailableFrontPrintTypes = () => {
    if (cardColor === 'white') {
      return ['none', 'gold', 'silver']; // カラー、金、銀
    } else {
      return ['white', 'gold', 'silver']; // 白、金、銀（カラーなし）
    }
  };

  // localStorageから読み込み
  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        const data = JSON.parse(saved);
        if (data.designMode) setDesignMode(data.designMode);
        if (data.selectedTemplates) setSelectedTemplates(data.selectedTemplates);
        if (data.cardColor) setCardColor(data.cardColor);
        if (data.cardOrientation) setCardOrientation(data.cardOrientation);
        if (data.globalFont) setGlobalFont(data.globalFont);
        if (data.frontData) setFrontData({ ...getDefaultSideData(data.cardColor === 'black'), ...data.frontData });
        if (data.backData) setBackData({ ...getDefaultSideData(data.cardColor === 'black'), ...data.backData });
        if (data.cardSide) setCardSide(data.cardSide);
      }
      // 金銀切り替えリロード後のスクロール位置復帰
      const savedScroll = sessionStorage.getItem(SCROLL_POSITION_KEY);
      if (savedScroll) {
        sessionStorage.removeItem(SCROLL_POSITION_KEY);
        setTimeout(() => {
          window.scrollTo(0, parseInt(savedScroll, 10));
        }, 100);
      }
    } catch (e) {
      console.error('Failed to load saved data:', e);
    }
    isInitialLoad.current = false;
  }, []);

  // localStorageに保存
  useEffect(() => {
    if (isInitialLoad.current) return;
    try {
      const data = {
        designMode,
        selectedTemplates,
        cardSide,
        cardColor,
        cardOrientation,
        globalFont,
        frontData,
        backData,
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      console.error('Failed to save data:', e);
    }
  }, [designMode, selectedTemplates, cardSide, cardColor, cardOrientation, globalFont, frontData, backData]);

  // Google Fonts読み込み
  useEffect(() => {
    const link = document.createElement('link');
    // 全フォントを読み込み
    const fontFamilies = GOOGLE_FONTS.map(f => f.name.replace(/ /g, '+')).join('&family=');
    link.href = `https://fonts.googleapis.com/css2?family=${fontFamilies}&display=swap`;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    return () => document.head.removeChild(link);
  }, []);

  // ページ読み込みアニメーション（初回のみ表示）
  useEffect(() => {
    const hasLoaded = sessionStorage.getItem('shurikenDesignerLoaded');
    if (hasLoaded) {
      // 既に読み込み済みの場合は即座に非表示
      setIsPageLoading(false);
    } else {
      // 初回のみローディング表示
      const timer = setTimeout(() => {
        setIsPageLoading(false);
        sessionStorage.setItem('shurikenDesignerLoaded', 'true');
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  // モバイル: ピンチズーム・pull-to-refresh 無効化
  useEffect(() => {
    // bodyにクラス追加
    document.body.classList.add('shuriken-designer-active');
    document.documentElement.classList.add('shuriken-designer-active');

    // ピンチズーム防止（2本指タッチ時、フォーム要素は除外）
    const preventZoom = (e) => {
      // フォーム要素は除外
      const target = e.target;
      if (target.tagName === 'INPUT' ||
          target.tagName === 'LABEL' ||
          target.tagName === 'SELECT' ||
          target.tagName === 'BUTTON' ||
          target.closest('label.upload-btn') ||
          target.closest('.upload-compact') ||
          target.closest('.radio-group') ||
          target.closest('.radio-option')) {
        return;
      }
      if (e.touches && e.touches.length > 1) {
        e.preventDefault();
      }
    };

    // ダブルタップズーム防止（フォーム要素は除外）
    let lastTouchEnd = 0;
    const preventDoubleTapZoom = (e) => {
      // フォーム要素は除外（ファイル入力、ラジオ、チェックボックス、セレクト等）
      const target = e.target;
      if (target.tagName === 'INPUT' ||
          target.tagName === 'LABEL' ||
          target.tagName === 'SELECT' ||
          target.tagName === 'BUTTON' ||
          target.closest('label.upload-btn') ||
          target.closest('.upload-compact') ||
          target.closest('.radio-group') ||
          target.closest('.radio-option')) {
        return;
      }
      const now = Date.now();
      if (now - lastTouchEnd <= 300) {
        e.preventDefault();
      }
      lastTouchEnd = now;
    };

    // pull-to-refresh 防止（ページ上部でのオーバースクロール）
    const preventPullToRefresh = (e) => {
      // スクロール可能な親要素内でのスクロールは許可
      const target = e.target;
      const scrollableParent = target.closest('.designer-form-panel, .designer-preview-panel, .capture-modal, textarea');
      if (scrollableParent) {
        const { scrollTop, scrollHeight, clientHeight } = scrollableParent;
        const isAtTop = scrollTop <= 0;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight;
        const deltaY = e.touches[0].clientY - (scrollableParent._lastTouchY || e.touches[0].clientY);
        scrollableParent._lastTouchY = e.touches[0].clientY;

        // 上端で下に引っ張る or 下端で上に引っ張る場合は防止
        if ((isAtTop && deltaY > 0) || (isAtBottom && deltaY < 0)) {
          // スクロール領域外へのオーバースクロールは防止しない（通常スクロール）
        }
        return; // スクロール可能領域内は通常動作
      }

      // スクロール不可領域でのタッチムーブは制限
      if (e.touches.length === 1) {
        const touch = e.touches[0];
        const startY = touch.clientY;
        if (window.scrollY === 0 && startY > 0) {
          // ページ最上部での下方向スワイプを検知した場合のみ防止
        }
      }
    };

    document.addEventListener('touchmove', preventZoom, { passive: false });
    document.addEventListener('touchend', preventDoubleTapZoom, { passive: false });
    document.addEventListener('gesturestart', (e) => e.preventDefault(), { passive: false });
    document.addEventListener('gesturechange', (e) => e.preventDefault(), { passive: false });
    document.addEventListener('gestureend', (e) => e.preventDefault(), { passive: false });

    return () => {
      document.body.classList.remove('shuriken-designer-active');
      document.documentElement.classList.remove('shuriken-designer-active');
      document.removeEventListener('touchmove', preventZoom);
      document.removeEventListener('touchend', preventDoubleTapZoom);
      document.removeEventListener('gesturestart', (e) => e.preventDefault());
      document.removeEventListener('gesturechange', (e) => e.preventDefault());
      document.removeEventListener('gestureend', (e) => e.preventDefault());
    };
  }, []);

  // 画面サイズに応じてズームを自動調整
  useEffect(() => {
    const calculateOptimalZoom = () => {
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        // スマホ: 画面幅に応じてズームを計算（ズーム値 / 200 = scale）
        // プレビュー領域のサイズを計算（パディングとヘッダー分を引く）
        const containerWidth = window.innerWidth - 40; // 左右パディング分
        const containerHeight = window.innerHeight * 0.28; // プレビュー領域の高さ
        const scaleX = containerWidth / cardWidth;
        const scaleY = containerHeight / cardHeight;
        const optimalScale = Math.min(scaleX, scaleY) * 0.95; // 5%マージン
        const optimalZoom = optimalScale * 200;
        // モバイルでは画面に収まるよう下限を50に（実際のscale 0.25）
        setPreviewZoom(Math.max(50, Math.min(optimalZoom, 300)));
      } else {
        // PC: 縦65%、横80%をデフォルト
        const defaultZoom = cardOrientation === 'vertical' ? 65 : 80;
        setPreviewZoom(defaultZoom);
      }
    };

    calculateOptimalZoom();
    window.addEventListener('resize', calculateOptimalZoom);
    return () => window.removeEventListener('resize', calculateOptimalZoom);
  }, [cardWidth, cardHeight, cardOrientation]);

  // ドロップダウン外クリックで閉じる
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (fontDropdownRef.current && !fontDropdownRef.current.contains(event.target)) {
        setFontDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // データ更新用ヘルパー
  const updateCurrentData = (updates) => {
    if (cardSide === 'front') {
      setFrontData(prev => ({ ...prev, ...updates }));
    } else {
      setBackData(prev => ({ ...prev, ...updates }));
    }
  };

  // スケール変更（中心を維持）
  const handleScaleChange = (elementType, newScale) => {
    const oldScale = elementType === 'template'
      ? templateScale
      : (elementType === 'logo' ? logoScale : logo2Scale);
    const position = elementType === 'template'
      ? templatePosition
      : (elementType === 'logo' ? logoPosition : logo2Position);

    // サイズの差分を計算
    let sizeDiffX, sizeDiffY;
    if (elementType === 'template') {
      // 背景画像: カードサイズ × スケール%
      sizeDiffX = cardWidth * (newScale - oldScale) / 100;
      sizeDiffY = cardHeight * (newScale - oldScale) / 100;
    } else {
      // アイコン: スケール値がそのままピクセル
      sizeDiffX = newScale - oldScale;
      sizeDiffY = newScale - oldScale;
    }

    // 位置を調整してセンターを維持
    const newX = position.x - sizeDiffX / 2;
    const newY = position.y - sizeDiffY / 2;

    updateCurrentData({
      [`${elementType}Scale`]: newScale,
      [`${elementType}Position`]: { x: newX, y: newY }
    });
  };

  // テンプレート画像アップロード
  const handleTemplateUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        updateCurrentData({
          templateImage: event.target.result,
          templateScale: 100,
        });
      };
      reader.readAsDataURL(file);
    }
    // iOS対応: inputをリセットして同じファイルの再選択を可能に
    e.target.value = '';
  };

  // ロゴ/アイコン1アップロード（クロップなし・元画像保持）
  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        updateCurrentData({ logoImage: event.target.result });
      };
      reader.readAsDataURL(file);
    }
    // iOS対応: inputをリセットして同じファイルの再選択を可能に
    e.target.value = '';
  };

  // ロゴ/アイコン2アップロード
  const handleLogo2Upload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        updateCurrentData({ logo2Image: event.target.result });
      };
      reader.readAsDataURL(file);
    }
    // iOS対応: inputをリセットして同じファイルの再選択を可能に
    e.target.value = '';
  };

  // フォーム入力
  const handleInputChange = (field, key, value) => {
    // 住所は最大2行まで
    if (field === 'address' && key === 'text') {
      const lines = value.split('\n');
      if (lines.length > 2) {
        value = lines.slice(0, 2).join('\n');
      }
    }
    updateCurrentData({
      formData: {
        ...formData,
        [field]: { ...formData[field], [key]: value }
      }
    });
  };

  // カード色変更時にテキスト色と印刷タイプをデフォルトに更新（両面に適用）
  const handleCardColorChange = (newColor) => {
    setCardColor(newColor);
    const defaultColors = newColor === 'white'
      ? { main: '#000000', sub: '#333333', detail: '#222222' }
      : { main: '#ffffff', sub: '#cccccc', detail: '#dddddd' };

    const updateSideData = (prevData) => {
      // 金銀は保持、カラー印刷(none)で黒カードに変更した場合は白印刷に変更
      let newPrintType = prevData.printType;
      if (prevData.printType === 'gold' || prevData.printType === 'silver') {
        // 金銀は保持
        newPrintType = prevData.printType;
      } else if (newColor === 'black' && prevData.printType === 'none') {
        // 黒カードでカラー印刷は不可なので白印刷に変更
        newPrintType = 'white';
      } else if (newColor === 'white' && prevData.printType === 'white') {
        // 白カードで白印刷ならカラーに戻す
        newPrintType = 'none';
      }

      return {
        ...prevData,
        printType: newPrintType,
        formData: {
          ...prevData.formData,
          name: { ...prevData.formData.name, color: defaultColors.main },
          nameKana: { ...prevData.formData.nameKana, color: defaultColors.sub },
          company: { ...prevData.formData.company, color: defaultColors.main },
          position: { ...prevData.formData.position, color: defaultColors.sub },
          phone: { ...prevData.formData.phone, color: defaultColors.detail },
          email: { ...prevData.formData.email, color: defaultColors.detail },
          address: { ...prevData.formData.address, color: defaultColors.detail },
          website: { ...prevData.formData.website, color: defaultColors.detail },
        }
      };
    };

    setFrontData(updateSideData);
    setBackData(updateSideData);
  };

  // 表裏切り替えハンドラー（リロードで確実に反映）
  const handleCardSideChange = (newSide) => {
    if (newSide === cardSide) return;

    // 現在のデータを保存してからリロード
    const savedData = {
      designMode,
      selectedTemplates,
      cardSide: newSide,
      cardColor,
      cardOrientation,
      globalFont,
      frontData,
      backData,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(savedData));
    // スクロール位置を保存してリロード
    sessionStorage.setItem(SCROLL_POSITION_KEY, window.scrollY.toString());
    window.location.reload();
  };

  // 印刷タイプ変更ハンドラー
  const handlePrintTypeChange = (newType) => {
    const oldType = printType;

    // 金銀間の直接切り替え時はデータ保存後にリロード
    const wasMetallic = oldType === 'gold' || oldType === 'silver';
    const isNewMetallic = newType === 'gold' || newType === 'silver';
    if (wasMetallic && isNewMetallic && oldType !== newType) {
      // 先にlocalStorageに保存してからリロード
      const newData = { ...currentData, printType: newType };
      const savedData = {
        designMode,
        selectedTemplates,
        cardSide,
        cardColor,
        cardOrientation,
        globalFont,
        frontData: cardSide === 'front' ? newData : frontData,
        backData: cardSide === 'back' ? newData : backData,
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(savedData));
      // スクロール位置を保存してリロード
      sessionStorage.setItem(SCROLL_POSITION_KEY, window.scrollY.toString());
      window.location.reload();
      return;
    }

    updateCurrentData({ printType: newType });

    // 表面の印刷タイプを変更した場合、裏面の選択肢が制限される可能性がある
    if (cardSide === 'front') {
      // 裏面の印刷タイプが新しい制限に違反している場合はリセット
      const newAvailableTypes = (() => {
        if (cardColor === 'white') {
          if (newType === 'none') return ['none'];
          return ['none', 'gold', 'silver'];
        } else {
          if (newType === 'white') return ['white'];
          return ['white', 'gold', 'silver'];
        }
      })();

      if (!newAvailableTypes.includes(backData.printType)) {
        setBackData(prev => ({ ...prev, printType: newAvailableTypes[0] }));
      }
    }
  };

  // センタースナップ（中央に近づくと吸い付く）
  const SNAP_THRESHOLD = 10; // スナップする距離（px）
  const snapToCenter = (x, y, elementWidth = 0, elementHeight = 0) => {
    const centerX = cardWidth / 2;
    const centerY = cardHeight / 2;
    // 要素の中心が画面中央に来るようにスナップ
    const elementCenterX = x + elementWidth / 2;
    const elementCenterY = y + elementHeight / 2;

    let snappedX = x;
    let snappedY = y;

    // X軸のスナップ（要素中心がカード中央に近い場合）
    if (Math.abs(elementCenterX - centerX) < SNAP_THRESHOLD) {
      snappedX = centerX - elementWidth / 2;
    }
    // Y軸のスナップ（要素中心がカード中央に近い場合）
    if (Math.abs(elementCenterY - centerY) < SNAP_THRESHOLD) {
      snappedY = centerY - elementHeight / 2;
    }

    return { x: snappedX, y: snappedY };
  };

  // テキスト位置更新
  const handleTextDrag = (field, e, data) => {
    // プレビュー領域内に制限（カード向きに応じて変動）
    const maxX = cardWidth - 10;
    const maxY = cardHeight - 10;
    let newX = Math.max(0, Math.min(data.x, maxX));
    let newY = Math.max(0, Math.min(data.y, maxY));

    // センタースナップ適用
    const snapped = snapToCenter(newX, newY, 0, 0);
    newX = Math.max(0, Math.min(snapped.x, maxX));
    newY = Math.max(0, Math.min(snapped.y, maxY));

    updateCurrentData({
      textPositions: {
        ...textPositions,
        [field]: { x: newX, y: newY }
      }
    });
  };

  // ロゴ1位置更新
  const handleLogoDrag = (e, data) => {
    const maxX = cardWidth - logoScale;
    const maxY = cardHeight - logoScale;
    let newX = Math.max(0, Math.min(data.x, maxX));
    let newY = Math.max(0, Math.min(data.y, maxY));

    // センタースナップ適用（ロゴサイズを考慮）
    const snapped = snapToCenter(newX, newY, logoScale, logoScale);
    newX = Math.max(0, Math.min(snapped.x, maxX));
    newY = Math.max(0, Math.min(snapped.y, maxY));

    updateCurrentData({ logoPosition: { x: newX, y: newY } });
  };

  // ロゴ2位置更新
  const handleLogo2Drag = (e, data) => {
    const maxX = cardWidth - logo2Scale;
    const maxY = cardHeight - logo2Scale;
    let newX = Math.max(0, Math.min(data.x, maxX));
    let newY = Math.max(0, Math.min(data.y, maxY));

    // センタースナップ適用（ロゴサイズを考慮）
    const snapped = snapToCenter(newX, newY, logo2Scale, logo2Scale);
    newX = Math.max(0, Math.min(snapped.x, maxX));
    newY = Math.max(0, Math.min(snapped.y, maxY));

    updateCurrentData({ logo2Position: { x: newX, y: newY } });
  };

  // 背景画像位置更新
  const handleTemplateDrag = (e, data) => {
    // 背景画像はカード外にも配置可能（ネガティブ座標OK）
    // センタースナップ適用
    const snapped = snapToCenter(data.x, data.y, 0, 0);
    updateCurrentData({ templatePosition: { x: snapped.x, y: snapped.y } });
  };

  // ロック切り替え
  const toggleLock = (elementKey) => {
    updateCurrentData({
      locks: {
        ...locks,
        [elementKey]: !locks[elementKey]
      }
    });
  };

  // 微調整モードでの移動処理
  const handleFineAdjust = (direction) => {
    if (!selectedElement) return;

    const step = adjustStep;
    let deltaX = 0;
    let deltaY = 0;

    switch (direction) {
      case 'up': deltaY = -step; break;
      case 'down': deltaY = step; break;
      case 'left': deltaX = -step; break;
      case 'right': deltaX = step; break;
      default: return;
    }

    // 要素タイプに応じて位置を更新（センタースナップ適用）
    if (selectedElement === 'template') {
      const newPos = snapToCenter(templatePosition.x + deltaX, templatePosition.y + deltaY, 0, 0);
      updateCurrentData({ templatePosition: newPos });
    } else if (selectedElement === 'logo') {
      const newPos = snapToCenter(logoPosition.x + deltaX, logoPosition.y + deltaY, logoScale, logoScale);
      updateCurrentData({ logoPosition: newPos });
    } else if (selectedElement === 'logo2') {
      const newPos = snapToCenter(logo2Position.x + deltaX, logo2Position.y + deltaY, logo2Scale, logo2Scale);
      updateCurrentData({ logo2Position: newPos });
    } else {
      // テキスト要素
      const newPos = snapToCenter(
        textPositions[selectedElement].x + deltaX,
        textPositions[selectedElement].y + deltaY,
        0, 0
      );
      updateCurrentData({
        textPositions: {
          ...textPositions,
          [selectedElement]: newPos
        }
      });
    }
  };

  // PCキーボード操作: 矢印キーで選択要素を移動（連打対応）
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedElement || locks[selectedElement]) return;

      // 入力フィールドにフォーカス中は無効
      const activeTag = document.activeElement?.tagName?.toLowerCase();
      if (activeTag === 'input' || activeTag === 'textarea' || activeTag === 'select') return;

      let direction = null;
      switch (e.key) {
        case 'ArrowUp': direction = 'up'; break;
        case 'ArrowDown': direction = 'down'; break;
        case 'ArrowLeft': direction = 'left'; break;
        case 'ArrowRight': direction = 'right'; break;
        case 'Escape':
          setSelectedElement(null);
          return;
        default:
          return;
      }

      e.preventDefault();

      // 移動量を計算
      const step = adjustStep;
      let deltaX = 0;
      let deltaY = 0;
      if (direction === 'up') deltaY = -step;
      if (direction === 'down') deltaY = step;
      if (direction === 'left') deltaX = -step;
      if (direction === 'right') deltaX = step;

      // 要素タイプに応じて位置を更新
      if (selectedElement === 'template') {
        updateCurrentData({
          templatePosition: {
            x: templatePosition.x + deltaX,
            y: templatePosition.y + deltaY
          }
        });
      } else if (selectedElement === 'logo') {
        updateCurrentData({
          logoPosition: {
            x: logoPosition.x + deltaX,
            y: logoPosition.y + deltaY
          }
        });
      } else if (selectedElement === 'logo2') {
        updateCurrentData({
          logo2Position: {
            x: logo2Position.x + deltaX,
            y: logo2Position.y + deltaY
          }
        });
      } else {
        // テキスト要素
        const currentPos = textPositions[selectedElement];
        if (currentPos) {
          updateCurrentData({
            textPositions: {
              ...textPositions,
              [selectedElement]: {
                x: currentPos.x + deltaX,
                y: currentPos.y + deltaY
              }
            }
          });
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedElement, locks, adjustStep, templatePosition, logoPosition, logo2Position, textPositions, updateCurrentData]);

  // 要素選択肢のリスト
  const elementOptions = [
    { key: 'template', label: '背景画像', hasContent: !!templateImage },
    { key: 'logo', label: 'アイコン1', hasContent: !!logoImage },
    { key: 'logo2', label: 'アイコン2', hasContent: !!logo2Image },
    { key: 'company', label: '会社名', hasContent: !!formData.company?.text },
    { key: 'position', label: '役職', hasContent: !!formData.position?.text },
    { key: 'nameKana', label: 'ふりがな', hasContent: !!formData.nameKana?.text },
    { key: 'name', label: '名前', hasContent: !!formData.name?.text },
    { key: 'phone', label: '電話番号', hasContent: !!formData.phone?.text },
    { key: 'email', label: 'メール', hasContent: !!formData.email?.text },
    { key: 'address', label: '住所', hasContent: !!formData.address?.text },
    { key: 'website', label: 'URL', hasContent: !!formData.website?.text },
    { key: 'freeText', label: '自由入力', hasContent: !!formData.freeText?.text },
  ];

  // リセット（両面とも初期化）
  const handleReset = () => {
    if (!window.confirm('表面・裏面の両方をリセットします。よろしいですか？')) return;

    setDesignMode('free');
    setSelectedTemplates([]);
    setCardSide('front');
    setCardColor('white');
    setCardOrientation('horizontal');
    setGlobalFont(GOOGLE_FONTS[0].value);
    // モバイルでは画面に収まるズームを計算
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      const cw = window.innerWidth - 40;
      const ch = window.innerHeight * 0.28;
      const scale = Math.min(cw / 1012, ch / 643) * 0.95;
      setPreviewZoom(Math.max(50, Math.min(scale * 200, 300)));
    } else {
      setPreviewZoom(80);
    }
    setFineAdjustMode(false);
    setSelectedElement(null);
    setAdjustStep(5);
    setFrontData(getDefaultSideData(false));
    setBackData(getDefaultSideData(false));
    localStorage.removeItem(STORAGE_KEY);
  };

  // JSONファイルとして保存
  const handleSaveToFile = () => {
    const saveData = {
      version: '1.0',
      savedAt: new Date().toISOString(),
      designMode,
      selectedTemplates,
      cardSide,
      cardColor,
      cardOrientation,
      globalFont,
      frontData,
      backData,
    };

    const blob = new Blob([JSON.stringify(saveData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const timestamp = new Date().toISOString().slice(0, 19).replace(/[:-]/g, '').replace('T', '_');
    a.download = `shuriken_design_${timestamp}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  // JSONファイルから読み込み
  const handleLoadFromFile = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const loadedData = JSON.parse(e.target.result);

        // データを復元
        if (loadedData.designMode) setDesignMode(loadedData.designMode);
        if (loadedData.selectedTemplates) setSelectedTemplates(loadedData.selectedTemplates);
        if (loadedData.cardSide) setCardSide(loadedData.cardSide);
        if (loadedData.cardColor) setCardColor(loadedData.cardColor);
        if (loadedData.cardOrientation) setCardOrientation(loadedData.cardOrientation);
        if (loadedData.globalFont) setGlobalFont(loadedData.globalFont);
        if (loadedData.frontData) setFrontData(loadedData.frontData);
        if (loadedData.backData) setBackData(loadedData.backData);

        // localStorageにも保存
        localStorage.setItem(STORAGE_KEY, JSON.stringify(loadedData));

        alert('デザインデータを読み込みました');
      } catch (error) {
        alert('ファイルの読み込みに失敗しました。正しいJSONファイルを選択してください。');
        console.error('Load error:', error);
      }
    };
    reader.readAsText(file);
    // inputをリセット（同じファイルを再度選択できるように）
    event.target.value = '';
  };

  // レンダリング完了を待つヘルパー関数
  const waitForRender = () => {
    return new Promise(resolve => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setTimeout(resolve, 100);
        });
      });
    });
  };

  // DOMを実際の画像に変換してからキャプチャする
  // metallicType: 'gold', 'silver', または 'print'（印刷用黒色）
  const preRenderMetallicElements = async (container, metallicType) => {
    const restorationData = [];

    // metallicType が指定されていない場合はスキップ
    if (!metallicType || (metallicType !== 'gold' && metallicType !== 'silver' && metallicType !== 'white' && metallicType !== 'print')) {
      return restorationData;
    }

    const isGold = metallicType === 'gold';
    const isWhite = metallicType === 'white';
    const isPrint = metallicType === 'print';

    // 金銀マスク画像を処理
    const metallicImages = container.querySelectorAll('.metallic-masked-image');
    for (const element of metallicImages) {
      const computedStyle = window.getComputedStyle(element);
      const maskImageUrl = computedStyle.maskImage || computedStyle.WebkitMaskImage;
      if (!maskImageUrl || maskImageUrl === 'none') continue;

      const urlMatch = maskImageUrl.match(/url\(["']?([^"')]+)["']?\)/);
      if (!urlMatch) continue;

      const imageSrc = urlMatch[1];
      const rect = element.getBoundingClientRect();
      const originalHTML = element.innerHTML;
      const originalStyles = {
        background: element.style.background,
        maskImage: element.style.maskImage,
        WebkitMaskImage: element.style.WebkitMaskImage,
        paddingBottom: element.style.paddingBottom,
        height: element.style.height,
        width: element.style.width,
        position: element.style.position,
        display: element.style.display,
        alignItems: element.style.alignItems,
        justifyContent: element.style.justifyContent,
      };

      // Canvas で描画（画像の実際のアスペクト比を維持）
      const imageData = await new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          // 画像の自然なサイズを使用（引き伸ばさない）
          const imgWidth = img.naturalWidth || img.width;
          const imgHeight = img.naturalHeight || img.height;
          canvas.width = imgWidth;
          canvas.height = imgHeight;

          // 塗りつぶし色（印刷モードは黒、白印刷は白、それ以外はグラデーション）
          if (isPrint) {
            ctx.fillStyle = '#000000';
          } else if (isWhite) {
            ctx.fillStyle = '#ffffff';
          } else {
            const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
            if (isGold) {
              gradient.addColorStop(0, '#D4AF37');
              gradient.addColorStop(0.25, '#FFD700');
              gradient.addColorStop(0.5, '#FFF8DC');
              gradient.addColorStop(0.75, '#FFD700');
              gradient.addColorStop(1, '#B8860B');
            } else {
              // シルバー（暗めに調整）
              gradient.addColorStop(0, '#707070');
              gradient.addColorStop(0.25, '#A0A0A0');
              gradient.addColorStop(0.5, '#C8C8C8');
              gradient.addColorStop(0.75, '#A0A0A0');
              gradient.addColorStop(1, '#606060');
            }
            ctx.fillStyle = gradient;
          }
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.globalCompositeOperation = 'destination-in';
          ctx.drawImage(img, 0, 0, imgWidth, imgHeight);

          resolve({ dataUrl: canvas.toDataURL('image/png'), imgWidth, imgHeight });
        };
        img.onerror = () => resolve(null);
        img.src = imageSrc;
      });

      if (imageData) {
        const { dataUrl, imgWidth, imgHeight } = imageData;
        // コンテナの表示サイズを取得
        const containerWidth = rect.width;
        const containerHeight = rect.height;

        // 画像のアスペクト比を計算してcontainと同じ挙動を再現
        const imgAspect = imgWidth / imgHeight;
        const containerAspect = containerWidth / containerHeight;

        let finalWidth, finalHeight;
        if (imgAspect > containerAspect) {
          // 画像が横長 → 幅に合わせる
          finalWidth = containerWidth;
          finalHeight = containerWidth / imgAspect;
        } else {
          // 画像が縦長 → 高さに合わせる
          finalHeight = containerHeight;
          finalWidth = containerHeight * imgAspect;
        }

        const imgEl = document.createElement('img');
        imgEl.src = dataUrl;
        // 明示的なサイズを設定（objectFitに依存しない）
        imgEl.style.width = `${finalWidth}px`;
        imgEl.style.height = `${finalHeight}px`;
        imgEl.style.display = 'block';

        element.innerHTML = '';
        element.appendChild(imgEl);
        element.style.background = 'none';
        element.style.maskImage = 'none';
        element.style.WebkitMaskImage = 'none';
        // paddingBottomをクリアして明示的な高さを設定
        element.style.paddingBottom = '0';
        element.style.width = `${containerWidth}px`;
        element.style.height = `${containerHeight}px`;
        element.style.display = 'block';

        restorationData.push({ element, originalHTML, originalStyles, type: 'image' });
      }
    }

    // 金銀テキストを処理
    const metallicTexts = container.querySelectorAll('.metallic-text');
    for (const element of metallicTexts) {
      const text = element.textContent;
      if (!text || text.trim() === '') continue;

      const computedStyle = window.getComputedStyle(element);
      const originalFontSize = parseFloat(computedStyle.fontSize);
      const fontFamily = computedStyle.fontFamily;
      const fontWeight = computedStyle.fontWeight;
      const writingMode = computedStyle.writingMode;
      const isVertical = writingMode === 'vertical-rl' || writingMode === 'vertical-lr';

      // 元の要素サイズを取得（位置ずれ防止）
      const originalRect = element.getBoundingClientRect();

      const originalHTML = element.innerHTML;
      const originalStyles = {
        background: element.style.background,
        WebkitBackgroundClip: element.style.WebkitBackgroundClip,
        WebkitTextFillColor: element.style.WebkitTextFillColor,
        backgroundClip: element.style.backgroundClip,
        writingMode: element.style.writingMode,
      };

      // 高解像度用に2倍のサイズでCanvasを作成
      const scale = 2;
      const fontSize = originalFontSize * scale;

      // 縦書きの場合は文字数に基づいて高さを計算（切れ防止）
      let canvasWidth, canvasHeight;
      if (isVertical) {
        const chars = [...text];
        const lineHeight = fontSize * 1.1;
        canvasWidth = Math.ceil(originalRect.width * scale);
        canvasHeight = Math.max(Math.ceil(originalRect.height * scale), Math.ceil(chars.length * lineHeight));
      } else {
        canvasWidth = Math.ceil(originalRect.width * scale);
        canvasHeight = Math.ceil(originalRect.height * scale);
      }

      const canvas = document.createElement('canvas');
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}`;

      // 塗りつぶし色（印刷モードは黒、それ以外はグラデーション）
      if (isPrint) {
        ctx.fillStyle = '#000000';
      } else {
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
        if (isGold) {
          gradient.addColorStop(0, '#bf953f');
          gradient.addColorStop(0.25, '#fcf6ba');
          gradient.addColorStop(0.5, '#b38728');
          gradient.addColorStop(0.75, '#fbf5b7');
          gradient.addColorStop(1, '#aa771c');
        } else {
          // シルバー（暗めに調整）
          gradient.addColorStop(0, '#707070');
          gradient.addColorStop(0.25, '#B0B0B0');
          gradient.addColorStop(0.5, '#808080');
          gradient.addColorStop(0.75, '#A8A8A8');
          gradient.addColorStop(1, '#606060');
        }
        ctx.fillStyle = gradient;
      }
      ctx.textBaseline = 'top';

      if (isVertical) {
        // 縦書き描画：元の要素と同じレイアウトで描画
        ctx.textAlign = 'center';
        const chars = [...text];
        const lineHeight = fontSize * 1.1;
        chars.forEach((char, i) => {
          ctx.fillText(char, canvas.width / 2, i * lineHeight);
        });
      } else {
        // 横書き描画
        ctx.textAlign = 'left';
        ctx.fillText(text, 0, fontSize * 0.1);
      }

      const imgEl = document.createElement('img');
      imgEl.src = canvas.toDataURL('image/png');
      // 元の要素と同じサイズで表示（Canvasは2倍で描画しているので縮小される→高解像度）
      imgEl.style.width = `${originalRect.width}px`;
      imgEl.style.height = `${originalRect.height}px`;
      imgEl.style.display = 'block';

      // 元のパディングを保存して一時的にリセット
      const originalPadding = element.style.padding;

      element.innerHTML = '';
      element.appendChild(imgEl);
      element.style.background = 'none';
      element.style.WebkitBackgroundClip = 'unset';
      element.style.WebkitTextFillColor = 'unset';
      element.style.backgroundClip = 'unset';
      element.style.padding = '0'; // パディングをリセット
      if (isVertical) {
        element.style.writingMode = 'horizontal-tb';
      }

      restorationData.push({ element, originalHTML, originalStyles: { ...originalStyles, padding: originalPadding }, type: 'text', isVertical });
    }

    return restorationData;
  };

  // 元の状態に戻す
  const restoreMetallicElements = (restorationData) => {
    for (const data of restorationData) {
      data.element.innerHTML = data.originalHTML;
      if (data.type === 'image') {
        data.element.style.background = data.originalStyles.background;
        data.element.style.maskImage = data.originalStyles.maskImage;
        data.element.style.WebkitMaskImage = data.originalStyles.WebkitMaskImage;
        data.element.style.paddingBottom = data.originalStyles.paddingBottom;
        data.element.style.height = data.originalStyles.height;
        data.element.style.width = data.originalStyles.width;
        data.element.style.position = data.originalStyles.position;
        data.element.style.display = data.originalStyles.display;
        data.element.style.alignItems = data.originalStyles.alignItems;
        data.element.style.justifyContent = data.originalStyles.justifyContent;
      } else {
        data.element.style.background = data.originalStyles.background;
        data.element.style.WebkitBackgroundClip = data.originalStyles.WebkitBackgroundClip;
        data.element.style.WebkitTextFillColor = data.originalStyles.WebkitTextFillColor;
        data.element.style.backgroundClip = data.originalStyles.backgroundClip;
        data.element.style.padding = data.originalStyles.padding || '';
        if (data.isVertical && data.originalStyles.writingMode) {
          data.element.style.writingMode = data.originalStyles.writingMode;
        }
      }
    }
  };

  // 縦書きテキストを画像に変換してキャプチャ用に準備
  // 注意：金銀テキスト（.metallic-text）はpreRenderMetallicElementsで処理済み
  const preRenderVerticalTexts = async (container, currentPrintType, isPrintMode = false) => {
    const restorationData = [];
    // text-element クラスを持つ全要素をチェック（metallic-textは除外）
    const textElements = container.querySelectorAll('.text-element:not(.metallic-text)');
    console.log('非メタリック縦書きテキスト要素数:', textElements.length);

    for (const element of textElements) {
      const computedStyle = window.getComputedStyle(element);
      const writingMode = computedStyle.writingMode;

      // 縦書きでない場合はスキップ
      if (writingMode !== 'vertical-rl' && writingMode !== 'vertical-lr') {
        continue;
      }

      const text = element.textContent;
      console.log('非メタリック縦書き要素処理中:', {
        text: `"${text}"`,
        writingMode
      });
      if (!text || !text.trim()) {
        console.log('テキストが空のためスキップ');
        continue;
      }

      const fontSize = parseFloat(computedStyle.fontSize);
      const fontFamily = computedStyle.fontFamily;

      // オリジナルの状態を保存
      const originalHTML = element.innerHTML;
      const originalStyle = element.getAttribute('style');

      // Canvasで縦書きテキストを描画
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // フォント設定
      ctx.font = `${fontSize}px ${fontFamily}`;

      // 各文字の幅を測定して最大幅を取得
      const chars = [...text];
      let maxCharWidth = 0;
      chars.forEach(char => {
        const metrics = ctx.measureText(char);
        if (metrics.width > maxCharWidth) maxCharWidth = metrics.width;
      });

      // キャンバスサイズ設定
      const charHeight = fontSize * 1.1;
      canvas.width = Math.ceil(maxCharWidth) + 4;
      canvas.height = Math.ceil(chars.length * charHeight) + 4;

      // フォント再設定（canvasサイズ変更後に必要）
      ctx.font = `${fontSize}px ${fontFamily}`;
      ctx.textBaseline = 'top';
      ctx.textAlign = 'center';

      // 色設定
      if (isPrintMode) {
        ctx.fillStyle = '#000000';
      } else if (currentPrintType === 'gold') {
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
        gradient.addColorStop(0, '#bf953f');
        gradient.addColorStop(0.25, '#fcf6ba');
        gradient.addColorStop(0.5, '#b38728');
        gradient.addColorStop(0.75, '#fbf5b7');
        gradient.addColorStop(1, '#aa771c');
        ctx.fillStyle = gradient;
      } else if (currentPrintType === 'silver') {
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
        gradient.addColorStop(0, '#707070');
        gradient.addColorStop(0.25, '#B0B0B0');
        gradient.addColorStop(0.5, '#808080');
        gradient.addColorStop(0.75, '#A8A8A8');
        gradient.addColorStop(1, '#606060');
        ctx.fillStyle = gradient;
      } else if (currentPrintType === 'white') {
        ctx.fillStyle = '#ffffff';
      } else {
        ctx.fillStyle = computedStyle.color;
      }

      // 各文字を縦に描画
      chars.forEach((char, i) => {
        ctx.fillText(char, canvas.width / 2, i * charHeight + 2);
      });

      const dataUrl = canvas.toDataURL('image/png');
      console.log('縦書きCanvas生成:', {
        text,
        canvasWidth: canvas.width,
        canvasHeight: canvas.height,
        fontSize,
        charsCount: chars.length,
        dataUrlLength: dataUrl.length
      });

      // 画像要素に置き換え
      const img = document.createElement('img');
      img.src = dataUrl;
      img.style.display = 'block';
      img.style.width = `${canvas.width}px`;
      img.style.height = `${canvas.height}px`;

      element.innerHTML = '';
      element.appendChild(img);
      element.style.writingMode = 'horizontal-tb';
      element.style.background = 'none';
      element.style.webkitBackgroundClip = 'unset';
      element.style.webkitTextFillColor = 'unset';

      restorationData.push({ element, originalHTML, originalStyle });
    }

    return restorationData;
  };

  // 縦書きテキストを復元
  const restoreVerticalTexts = (restorationData) => {
    for (const data of restorationData) {
      data.element.innerHTML = data.originalHTML;
      if (data.originalStyle) {
        data.element.setAttribute('style', data.originalStyle);
      } else {
        data.element.removeAttribute('style');
      }
    }
  };

  // 画像キャプチャ処理
  const handleCapture = async () => {
    if (!previewRef.current) return;

    setIsCapturing(true);

    // グリッドを非表示にして保存
    const originalShowGrid = showGrid;
    setShowGrid(false);
    await waitForRender();

    try {
      const results = {
        front: { preview: null, print: null },
        back: { preview: null, print: null },
      };

      // 現在の面とズームを保存
      const originalSide = cardSide;
      const originalZoom = previewZoom;

      // ズームを200%に固定（キャプチャ用 - scale(1)で実寸キャプチャ）
      setPreviewZoom(200);
      await waitForRender();

      const html2canvasOptions = {
        backgroundColor: null,
        scale: 2,
        useCORS: true,
        logging: false,
      };

      // 表面をキャプチャ
      setCardSide('front');
      await waitForRender();
      await new Promise(resolve => setTimeout(resolve, 500));

      const wrapper = previewRef.current.querySelector('.card-preview-wrapper');

      // 表面の印刷タイプを取得
      const frontMetallicType = frontData.printType;
      const needsFrontPreviewRender = frontMetallicType === 'gold' || frontMetallicType === 'silver' || (frontMetallicType === 'white' && cardColor === 'black');

      // 金銀白の場合は事前レンダリング（html2canvasはCSSマスク・background-clipに非対応）
      let frontPreviewRestorationData = [];
      if (needsFrontPreviewRender) {
        frontPreviewRestorationData = await preRenderMetallicElements(wrapper, frontMetallicType);
      }
      // 縦書きテキストを画像に変換
      const verticalRestorationData = await preRenderVerticalTexts(wrapper, frontMetallicType, false);
      await new Promise(resolve => setTimeout(resolve, 100));

      // 表面プレビュー版キャプチャ（お客様用：金銀効果付き）
      const frontPreviewCanvas = await html2canvas(wrapper, html2canvasOptions);
      results.front.preview = frontPreviewCanvas.toDataURL('image/png');

      // 元に戻す
      restoreVerticalTexts(verticalRestorationData);
      if (needsFrontPreviewRender) {
        restoreMetallicElements(frontPreviewRestorationData);
      }

      // 表面印刷版キャプチャ（店舗用：金銀白→黒、透過維持）
      const frontPrintType = frontData.printType;
      const needsPrintRender = frontPrintType === 'gold' || frontPrintType === 'silver' || (frontPrintType === 'white' && cardColor === 'black');

      // 先にcaptureModeを設定してReactを再レンダリング
      setCaptureMode('print');
      await waitForRender();
      await new Promise(resolve => setTimeout(resolve, 300));

      // 金銀の場合は事前レンダリングで黒色に変換（React再レンダリング後に実行）
      let frontPrintRestorationData = [];
      if (needsPrintRender) {
        frontPrintRestorationData = await preRenderMetallicElements(wrapper, 'print');
      }
      // 縦書きテキストを画像に変換（印刷版は黒）
      const frontPrintVerticalRestorationData = await preRenderVerticalTexts(wrapper, frontPrintType, true);
      await new Promise(resolve => setTimeout(resolve, 100));

      const frontPrintCanvas = await html2canvas(wrapper, html2canvasOptions);
      results.front.print = frontPrintCanvas.toDataURL('image/png');

      restoreVerticalTexts(frontPrintVerticalRestorationData);
      if (needsPrintRender) {
        restoreMetallicElements(frontPrintRestorationData);
      }
      setCaptureMode(null);

      // 裏面に内容があるかチェック
      const hasBackContent = backData.templateImage ||
        backData.logoImage ||
        backData.logo2Image ||
        Object.values(backData.formData).some(field => field.text && field.text.trim() !== '');

      if (hasBackContent) {
        // 裏面をキャプチャ
        setCardSide('back');
        await waitForRender();
        await new Promise(resolve => setTimeout(resolve, 500));

        // 裏面の印刷タイプを取得
        const backMetallicType = backData.printType;
        const needsBackPreviewRender = backMetallicType === 'gold' || backMetallicType === 'silver' || (backMetallicType === 'white' && cardColor === 'black');

        // 金銀白の場合は事前レンダリング（html2canvasはCSSマスク・background-clipに非対応）
        let backPreviewRestorationData = [];
        if (needsBackPreviewRender) {
          backPreviewRestorationData = await preRenderMetallicElements(wrapper, backMetallicType);
        }
        // 縦書きテキストを画像に変換
        const backVerticalRestorationData = await preRenderVerticalTexts(wrapper, backMetallicType, false);
        await new Promise(resolve => setTimeout(resolve, 100));

        // 裏面プレビュー版キャプチャ（お客様用：金銀効果付き）
        const backPreviewCanvas = await html2canvas(wrapper, html2canvasOptions);
        results.back.preview = backPreviewCanvas.toDataURL('image/png');

        // 元に戻す
        restoreVerticalTexts(backVerticalRestorationData);
        if (needsBackPreviewRender) {
          restoreMetallicElements(backPreviewRestorationData);
        }

        // 裏面印刷版キャプチャ（店舗用：金銀白→黒、透過維持）
        const backPrintType = backData.printType;
        const needsBackPrintRender = backPrintType === 'gold' || backPrintType === 'silver' || (backPrintType === 'white' && cardColor === 'black');

        // 先にcaptureModeを設定してReactを再レンダリング
        setCaptureMode('print');
        await waitForRender();
        await new Promise(resolve => setTimeout(resolve, 300));

        // 金銀の場合は事前レンダリングで黒色に変換（React再レンダリング後に実行）
        let backPrintRestorationData = [];
        if (needsBackPrintRender) {
          backPrintRestorationData = await preRenderMetallicElements(wrapper, 'print');
        }
        // 縦書きテキストを画像に変換（印刷版は黒）
        const backPrintVerticalRestorationData = await preRenderVerticalTexts(wrapper, backPrintType, true);
        await new Promise(resolve => setTimeout(resolve, 100));

        const backPrintCanvas = await html2canvas(wrapper, html2canvasOptions);
        results.back.print = backPrintCanvas.toDataURL('image/png');

        restoreVerticalTexts(backPrintVerticalRestorationData);
        if (needsBackPrintRender) {
          restoreMetallicElements(backPrintRestorationData);
        }
        setCaptureMode(null);
      }

      // 元の状態に戻す
      setCardSide(originalSide);
      setPreviewZoom(originalZoom);

      setCapturedImages(results);
      setModalPreviewSide('front');
      setShowCaptureModal(true);
    } catch (error) {
      console.error('キャプチャエラー:', error);
      alert('画像の生成に失敗しました。');
    } finally {
      setIsCapturing(false);
      setCaptureMode(null);
      // グリッド状態を復元
      setShowGrid(originalShowGrid);
    }
  };

  // GASに送信
  const handleSubmitToGAS = async () => {
    if (!capturedImages) return;

    // 入力バリデーション
    if (!customerName.trim()) {
      alert('お名前を入力してください。');
      return;
    }
    if (!customerEmail.trim()) {
      alert('メールアドレスを入力してください。');
      return;
    }
    // 簡易メールバリデーション
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(customerEmail)) {
      alert('正しいメールアドレスを入力してください。');
      return;
    }

    // GAS URLが設定されていない場合
    if (!GAS_WEBAPP_URL) {
      alert('送信先が設定されていません。\n管理者にお問い合わせください。');
      return;
    }

    setIsSubmitting(true);

    try {
      // 送信データを作成
      const submitData = {
        customerInfo: {
          name: customerName.trim(),
          email: customerEmail.trim(),
        },
        images: {
          frontPreview: capturedImages.front.preview,
          frontPrint: capturedImages.front.print,
          backPreview: capturedImages.back.preview || null,
          backPrint: capturedImages.back.print || null,
        },
        designData: {
          cardColor: cardColor,
          cardOrientation: cardOrientation,
          printType: frontData.printType,
          backPrintType: backData.printType,
          hasBackPrint: !!(capturedImages.back.preview),
          totalPrice: calculateTotalPrice(),
          frontFormData: frontData.formData,
          backFormData: backData.formData,
          globalFont: globalFont,
        },
        timestamp: new Date().toISOString(),
      };

      // hidden formで送信（CORS回避）
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = GAS_WEBAPP_URL;
      form.target = 'gas-iframe';
      form.style.display = 'none';
      form.enctype = 'application/x-www-form-urlencoded';

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'data';
      input.value = JSON.stringify(submitData);
      form.appendChild(input);

      // iframe作成
      let iframe = document.getElementById('gas-iframe');
      if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.id = 'gas-iframe';
        iframe.name = 'gas-iframe';
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
      }

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);

      // 送信完了を待つ
      await new Promise(resolve => setTimeout(resolve, 2500));

      setShowCaptureModal(false);
      setShowSuccessModal(true);
      setCustomerName('');
      setCustomerEmail('');

    } catch (error) {
      console.error('送信エラー:', error);
      alert('送信に失敗しました。\nしばらく経ってからお試しください。');
    } finally {
      setIsSubmitting(false);
    }
  };

  // 合計金額を計算
  const calculateTotalPrice = () => {
    let price = 0;

    // カード料金
    if (cardColor === 'black') {
      price += 500;
    }

    // 印刷タイプ料金（表面）
    if (frontData.printType === 'gold' || frontData.printType === 'silver') {
      price += 10000;
    } else if (frontData.printType === 'none' || frontData.printType === 'white') {
      price += 5500; // カラー印刷または白印刷
    }

    // 裏面印刷
    const hasBackContent = backData.templateImage ||
      backData.logoImage ||
      backData.logo2Image ||
      Object.values(backData.formData).some(field => field.text && field.text.trim() !== '');

    if (hasBackContent) {
      // 裏面が金銀の場合は3000円のみ、それ以外は2000円
      if (backData.printType === 'gold' || backData.printType === 'silver') {
        price += 3000;
      } else {
        price += 2000;
      }
    }

    return price;
  };

  // 印刷用の色を取得（金銀→黒、黒カード→白カードで黒）
  const getPrintModeStyles = () => {
    if (captureMode !== 'print') return {};

    const currentPrintType = currentData.printType;
    const isCurrentMetallic = currentPrintType === 'gold' || currentPrintType === 'silver';

    return {
      cardBackground: '#ffffff', // 常に白カード
      textColor: '#000000', // 常に黒文字
      imageFilter: isCurrentMetallic ? 'grayscale(100%) brightness(0)' : 'grayscale(100%) brightness(0)',
    };
  };

  const printStyles = getPrintModeStyles();

  // テキスト表示内容を取得（入力がある場合のみ表示）
  const getDisplayText = (field) => {
    const text = formData[field]?.text;
    if (!text || text.trim() === '') return null;
    if (field === 'phone') return `TEL: ${text}`;
    if (field === 'email') return `mail: ${text}`;
    return text;
  };

  // フィールドラベル
  const fieldLabels = {
    name: '名前',
    nameKana: 'フリガナ',
    company: '会社名',
    position: '役職',
    phone: '電話番号',
    email: 'メール',
    address: '住所',
    website: 'Web',
    freeText: '自由入力',
  };

  const fieldPlaceholders = {
    name: '手裏剣 太郎',
    nameKana: 'シュリケン タロウ',
    company: '株式会社○○',
    position: '代表取締役',
    phone: '090-1234-5678',
    email: 'example@email.com',
    address: '〒000-0000 ○○県○○市...',
    website: 'https://example.com',
    freeText: '自由にテキストを入力\n改行も使えます',
  };

  // 金銀選択時かどうか
  const isMetallic = printType === 'gold' || printType === 'silver';
  // 白印刷（黒カード時）かどうか
  const isWhitePrint = printType === 'white' && cardColor === 'black';
  // マスクが必要かどうか（金銀または白印刷時）
  const needsMask = isMetallic || isWhitePrint;

  // 画像に適用するフィルターを取得
  const getImageFilter = () => {
    // 印刷モードでは黒に変換
    if (captureMode === 'print') {
      return 'grayscale(100%) brightness(0)';
    }
    // 金銀・白印刷選択時はマスクで塗りつぶすのでフィルターは使わない
    if (needsMask) {
      return 'none';
    }
    // 黒カードでカラー印刷の場合は白に変換
    if (cardColor === 'black') {
      return 'grayscale(100%) brightness(2) contrast(0.5)';
    }
    // 白カードでカラー印刷の場合はフィルターなし
    return 'none';
  };

  // 金銀・白の塗りつぶし（光沢感付き）
  const getMetallicFill = () => {
    // 印刷モードでは黒一色
    if (captureMode === 'print') {
      return '#000000';
    }
    // 白印刷（黒カード時）は白一色
    if (isWhitePrint) {
      return '#ffffff';
    }
    if (printType === 'gold') {
      if (cardColor === 'black') {
        // 黒カード用：より明るい金色
        return 'linear-gradient(135deg, #FFD700 0%, #FFEC8B 20%, #FFFACD 40%, #FFFFFF 50%, #FFFACD 60%, #FFD700 80%, #DAA520 100%)';
      }
      return 'linear-gradient(135deg, #D4AF37 0%, #FFD700 25%, #FFF8DC 45%, #FFD700 55%, #B8860B 75%, #D4AF37 100%)';
    }
    if (printType === 'silver') {
      if (cardColor === 'black') {
        // 黒カード用：暗めのシルバー（視認性向上）
        return `linear-gradient(135deg,
          #808080 0%,
          #A8A8A8 5%,
          #C8C8C8 12%,
          #B0B0B0 18%,
          #C8C8C8 25%,
          #A0A0A0 32%,
          #C0C0C0 40%,
          #D0D0D0 50%,
          #C0C0C0 60%,
          #A8A8A8 68%,
          #C8C8C8 75%,
          #B8B8B8 82%,
          #C0C0C0 88%,
          #A0A0A0 94%,
          #808080 100%)`;
      }
      // 白カード用：暗めのシルバー（視認性向上）
      return `linear-gradient(135deg,
        #505050 0%,
        #787878 8%,
        #A8A8A8 15%,
        #909090 22%,
        #686868 30%,
        #A0A0A0 38%,
        #B8B8B8 45%,
        #C0C0C0 50%,
        #B8B8B8 55%,
        #989898 62%,
        #707070 70%,
        #A8A8A8 78%,
        #888888 85%,
        #606060 92%,
        #505050 100%)`;
    }
    return 'none';
  };


  return (
    <div className="shuriken-designer">
      {/* ヘッダー */}
      <header className="designer-header">
        <Link to="/shuriken" className="designer-back">
          ← 戻る
        </Link>
        <h1>
          <img src={shurikenLogo} alt="" className="designer-logo" />
          名刺デザイン
        </h1>
        <div className="designer-header-actions">
          <label className="header-btn load-btn" title="保存したデータを読み込み">
            <input
              type="file"
              accept=".json"
              onChange={handleLoadFromFile}
              hidden
            />
            📂 読込
          </label>
          <button className="header-btn save-btn" onClick={handleSaveToFile} title="作業内容をJSONファイルに保存">
            💾 保存
          </button>
        </div>
      </header>

      {/* メインコンテンツ - 2カラム */}
      <div className="designer-main two-column">
        {/* 左側: フォーム */}
        <div className="designer-form-panel">
          <h3>編集</h3>

          {/* テンプレートモードの場合 */}
          {designMode === 'template' && (
            <div className="form-section template-section">
              <h4>テンプレート選択</h4>
              <p className="template-coming-soon">
                テンプレートは現在準備中です。<br />
                複数のテンプレートから選択できるようになります。
              </p>
            </div>
          )}

          {/* カード色選択（表面編集時のみ表示） */}
          {cardSide === 'front' && (
            <div className="form-section card-color-section">
              <h4>カードの色（両面共通）</h4>
              <div className="radio-group">
                <label className={`radio-option ${cardColor === 'white' ? 'selected' : ''}`}>
                  <input
                    type="radio"
                    name="cardColor"
                    value="white"
                    checked={cardColor === 'white'}
                    onChange={() => handleCardColorChange('white')}
                  />
                  <span className="radio-label">白カード</span>
                </label>
                <label className={`radio-option ${cardColor === 'black' ? 'selected' : ''}`}>
                  <input
                    type="radio"
                    name="cardColor"
                    value="black"
                    checked={cardColor === 'black'}
                    onChange={() => handleCardColorChange('black')}
                  />
                  <span className="radio-label">黒カード</span>
                </label>
              </div>
            </div>
          )}

          {/* カードの向き選択（表面編集時のみ表示） */}
          {cardSide === 'front' && (
            <div className="form-section card-orientation-section">
              <h4>カードの向き（両面共通）</h4>
              <div className="radio-group">
                <label className={`radio-option ${cardOrientation === 'horizontal' ? 'selected' : ''}`}>
                  <input
                    type="radio"
                    name="cardOrientation"
                    value="horizontal"
                    checked={cardOrientation === 'horizontal'}
                    onChange={() => setCardOrientation('horizontal')}
                  />
                  <span className="radio-label">横向き</span>
                </label>
                <label className={`radio-option ${cardOrientation === 'vertical' ? 'selected' : ''}`}>
                  <input
                    type="radio"
                    name="cardOrientation"
                    value="vertical"
                    checked={cardOrientation === 'vertical'}
                    onChange={() => setCardOrientation('vertical')}
                  />
                  <span className="radio-label">縦向き</span>
                </label>
              </div>
            </div>
          )}

          {/* 印刷タイプ選択 */}
          <div className="form-section print-type-section">
            <h4>印刷の種類（{cardSide === 'front' ? '表面' : '裏面'}）</h4>
            {(() => {
              const availableTypes = cardSide === 'front'
                ? getAvailableFrontPrintTypes()
                : getAvailableBackPrintTypes();

              const typeLabels = {
                none: 'カラー印刷',
                white: '白印刷',
                gold: '金色',
                silver: '銀色',
              };

              const typeClasses = {
                gold: 'gold-text',
                silver: 'silver-text',
              };

              return (
                <div className="radio-group vertical">
                  {availableTypes.map(type => (
                    <label
                      key={type}
                      className={`radio-option ${printType === type ? 'selected' : ''}`}
                    >
                      <input
                        type="radio"
                        name="printType"
                        value={type}
                        checked={printType === type}
                        onChange={() => handlePrintTypeChange(type)}
                      />
                      <span className={`radio-label ${typeClasses[type] || ''}`}>
                        {typeLabels[type]}
                      </span>
                    </label>
                  ))}
                  {cardSide === 'back' && availableTypes.length === 1 && (
                    <p className="print-type-note">
                      ※ 表面で{cardColor === 'white' ? 'カラー' : '白'}印刷を選択しているため、裏面も同じ設定です
                    </p>
                  )}
                </div>
              );
            })()}
          </div>

          {/* 背景画像アップロード */}
          <div className="form-section">
            <div className="section-header-with-lock">
              <h4>背景画像（{cardSide === 'front' ? '表面' : '裏面'}）</h4>
              {templateImage && (
                <button
                  className={`lock-btn ${locks.template ? 'locked' : ''}`}
                  onClick={() => toggleLock('template')}
                  title={locks.template ? 'ロック解除' : 'ロック'}
                >
                  {locks.template ? '🔒' : '🔓'}
                </button>
              )}
            </div>
            <div className="upload-compact">
              {templateImage ? (
                <div className="upload-thumb">
                  <img src={templateImage} alt="背景" />
                  <button onClick={() => updateCurrentData({ templateImage: null, templatePosition: { x: 0, y: 0 } })}>✕</button>
                </div>
              ) : (
                <label className="upload-btn">
                  <input type="file" accept="image/*" onChange={handleTemplateUpload} hidden />
                  📤 アップロード
                </label>
              )}
            </div>
            {templateImage && (
              <div className={`size-slider ${locks.template ? 'locked' : ''}`}>
                <label>サイズ: {templateScale}%</label>
                <input
                  type="range"
                  min="10"
                  max="300"
                  value={templateScale}
                  onChange={(e) => handleScaleChange('template', Number(e.target.value))}
                  disabled={locks.template === true}
                />
              </div>
            )}
          </div>

          {/* アイコン1アップロード */}
          <div className="form-section">
            <div className="section-header-with-lock">
              <h4>アイコン1（{cardSide === 'front' ? '表面' : '裏面'}）</h4>
              {logoImage && (
                <button
                  className={`lock-btn ${locks.logo ? 'locked' : ''}`}
                  onClick={() => toggleLock('logo')}
                  title={locks.logo ? 'ロック解除' : 'ロック'}
                >
                  {locks.logo ? '🔒' : '🔓'}
                </button>
              )}
            </div>
            <div className="upload-compact">
              {logoImage ? (
                <div className="upload-thumb">
                  <img src={logoImage} alt="アイコン1" />
                  <button onClick={() => updateCurrentData({ logoImage: null })}>✕</button>
                </div>
              ) : (
                <label className="upload-btn">
                  <input type="file" accept="image/*" onChange={handleLogoUpload} hidden />
                  🖼️ アップロード
                </label>
              )}
            </div>
            {logoImage && (
              <div className={`size-slider ${locks.logo ? 'locked' : ''}`}>
                <label>サイズ: {logoScale}%</label>
                <input
                  type="range"
                  min="10"
                  max="200"
                  value={logoScale}
                  onChange={(e) => handleScaleChange('logo', Number(e.target.value))}
                  disabled={locks.logo === true}
                />
              </div>
            )}
          </div>

          {/* アイコン2アップロード */}
          <div className="form-section">
            <div className="section-header-with-lock">
              <h4>アイコン2（{cardSide === 'front' ? '表面' : '裏面'}）</h4>
              {logo2Image && (
                <button
                  className={`lock-btn ${locks.logo2 ? 'locked' : ''}`}
                  onClick={() => toggleLock('logo2')}
                  title={locks.logo2 ? 'ロック解除' : 'ロック'}
                >
                  {locks.logo2 ? '🔒' : '🔓'}
                </button>
              )}
            </div>
            <div className="upload-compact">
              {logo2Image ? (
                <div className="upload-thumb">
                  <img src={logo2Image} alt="アイコン2" />
                  <button onClick={() => updateCurrentData({ logo2Image: null })}>✕</button>
                </div>
              ) : (
                <label className="upload-btn">
                  <input type="file" accept="image/*" onChange={handleLogo2Upload} hidden />
                  🖼️ アップロード
                </label>
              )}
            </div>
            {logo2Image && (
              <div className={`size-slider ${locks.logo2 ? 'locked' : ''}`}>
                <label>サイズ: {logo2Scale}%</label>
                <input
                  type="range"
                  min="10"
                  max="200"
                  value={logo2Scale}
                  onChange={(e) => handleScaleChange('logo2', Number(e.target.value))}
                  disabled={locks.logo2 === true}
                />
              </div>
            )}
          </div>

          {/* 画像アップロード注意書き */}
          {(printType === 'gold' || printType === 'silver' || printType === 'white') && (
            <div className="upload-warning">
              ※金・銀・白色で画像をアップロードする際、画像は背景透過にしないと塗りつぶしになってしまいます。
            </div>
          )}

          {/* テキスト入力フォーム */}
          <div className="form-section">
            <h4>テキスト情報</h4>

            {/* フォント選択 - カスタムドロップダウン */}
            <div className="global-font-select" ref={fontDropdownRef}>
              <label>フォント（{GOOGLE_FONTS.length}種類）</label>
              <div
                className="font-dropdown-trigger"
                onClick={() => setFontDropdownOpen(!fontDropdownOpen)}
              >
                <span
                  className="font-dropdown-selected"
                  style={{ fontFamily: globalFont }}
                >
                  {GOOGLE_FONTS.find(f => f.value === globalFont)?.name || 'フォントを選択'}
                </span>
                <span className="font-dropdown-arrow">{fontDropdownOpen ? '▲' : '▼'}</span>
              </div>
              {fontDropdownOpen && (
                <div className="font-dropdown-menu">
                  {/* カテゴリごとにグループ化 */}
                  {['ゴシック', '丸ゴシック', '明朝', '行書', '手書き', 'ポップ', 'デザイン'].map(category => {
                    const fontsInCategory = GOOGLE_FONTS.filter(f => f.category === category);
                    if (fontsInCategory.length === 0) return null;
                    return (
                      <div key={category} className="font-category-group">
                        <div className="font-category-label">{category}</div>
                        {fontsInCategory.map(font => (
                          <div
                            key={font.name}
                            className={`font-dropdown-item ${globalFont === font.value ? 'selected' : ''}`}
                            onClick={() => {
                              setGlobalFont(font.value);
                              setFontDropdownOpen(false);
                            }}
                          >
                            <span className="font-item-name">{font.name}</span>
                            <span
                              className="font-item-sample"
                              style={{ fontFamily: font.value }}
                            >
                              あいうえお 手裏剣太郎
                            </span>
                          </div>
                        ))}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {Object.entries(formData).map(([field, data]) => (
              <div key={field} className="form-field">
                <div className="field-header">
                  <label>{fieldLabels[field]}</label>
                  <button
                    className={`lock-btn small ${locks[field] ? 'locked' : ''}`}
                    onClick={() => toggleLock(field)}
                    title={locks[field] ? 'ロック解除' : 'ロック'}
                  >
                    {locks[field] ? '🔒' : '🔓'}
                  </button>
                  <div className="field-controls">
                    <span className="control-label">色</span>
                    {printType === 'none' ? (
                      <input
                        type="color"
                        value={data.color}
                        onChange={(e) => handleInputChange(field, 'color', e.target.value)}
                        title="文字色"
                      />
                    ) : (
                      <span
                        className={`color-locked ${printType}`}
                        title={
                          printType === 'gold' ? '金色固定' :
                          printType === 'silver' ? '銀色固定' : '白色固定'
                        }
                      >
                        {printType === 'gold' ? '🥇' :
                         printType === 'silver' ? '🥈' : '⬜'}
                      </span>
                    )}
                    <span className="control-label">サイズ</span>
                    <input
                      type="number"
                      value={data.fontSize}
                      onChange={(e) => handleInputChange(field, 'fontSize', parseInt(e.target.value) || 10)}
                      min="6"
                      max="200"
                      title="フォントサイズ"
                      className="font-size-input"
                    />
                    <div className="font-size-buttons">
                      <button
                        type="button"
                        className="font-size-btn"
                        onClick={() => handleInputChange(field, 'fontSize', Math.max(6, data.fontSize - 5))}
                        title="-5"
                      >-5</button>
                      <button
                        type="button"
                        className="font-size-btn"
                        onClick={() => handleInputChange(field, 'fontSize', Math.max(6, data.fontSize - 1))}
                        title="-1"
                      >-1</button>
                      <button
                        type="button"
                        className="font-size-btn"
                        onClick={() => handleInputChange(field, 'fontSize', Math.min(200, data.fontSize + 1))}
                        title="+1"
                      >+1</button>
                      <button
                        type="button"
                        className="font-size-btn"
                        onClick={() => handleInputChange(field, 'fontSize', Math.min(200, data.fontSize + 5))}
                        title="+5"
                      >+5</button>
                    </div>
                    <label className="vertical-text-checkbox">
                      <input
                        type="checkbox"
                        checked={data.vertical || false}
                        onChange={(e) => handleInputChange(field, 'vertical', e.target.checked)}
                      />
                      <span>縦書き</span>
                    </label>
                  </div>
                </div>
                {(field === 'address' || field === 'freeText') ? (
                  <textarea
                    value={data.text}
                    onChange={(e) => handleInputChange(field, 'text', e.target.value)}
                    placeholder={fieldPlaceholders[field]}
                    style={{ fontFamily: globalFont }}
                    rows={field === 'freeText' ? 5 : 2}
                  />
                ) : (
                  <input
                    type="text"
                    value={data.text}
                    onChange={(e) => handleInputChange(field, 'text', e.target.value)}
                    placeholder={fieldPlaceholders[field]}
                    style={{ fontFamily: globalFont }}
                  />
                )}
              </div>
            ))}
          </div>

          {/* 金額明細 */}
          <div className="price-breakdown">
            <h4>金額明細</h4>
            <div className="price-items">
              <div className="price-item">
                <span className="price-label">カード</span>
                <span className="price-value">
                  {cardColor === 'white' ? '白カード' : '黒カード'}
                </span>
                <span className="price-amount">
                  ¥{cardColor === 'white' ? '0' : '500'}
                </span>
              </div>
              <div className="price-item">
                <span className="price-label">表面印刷</span>
                <span className="price-value">
                  {frontData.printType === 'gold' || frontData.printType === 'silver'
                    ? '金銀印刷'
                    : frontData.printType === 'white'
                      ? '白印刷'
                      : 'カラー印刷'}
                </span>
                <span className="price-amount">
                  ¥{frontData.printType === 'gold' || frontData.printType === 'silver' ? '10,000' : '5,500'}
                </span>
              </div>
              {(() => {
                // 裏面に何かコンテンツがあるかチェック
                const hasBackContent = backData.templateImage ||
                  backData.logoImage ||
                  backData.logo2Image ||
                  Object.values(backData.formData).some(field => field.text && field.text.trim() !== '');

                if (hasBackContent) {
                  const isBackMetallic = backData.printType === 'gold' || backData.printType === 'silver';
                  const isBackWhite = backData.printType === 'white';
                  return (
                    <div className="price-item">
                      <span className="price-label">裏面印刷</span>
                      <span className="price-value">
                        {isBackMetallic ? '金銀印刷' : isBackWhite ? '白印刷' : 'カラー印刷'}
                      </span>
                      <span className="price-amount">
                        ¥{isBackMetallic ? '3,000' : '2,000'}
                      </span>
                    </div>
                  );
                }
                return null;
              })()}
              <div className="price-total">
                <span className="price-label">合計<span className="price-tax-small">（税込）</span></span>
                <span className="price-amount">
                  ¥{(() => {
                    let total = 0;
                    // カード代
                    total += cardColor === 'black' ? 500 : 0;
                    // 表面印刷
                    total += (frontData.printType === 'gold' || frontData.printType === 'silver') ? 10000 : 5500;
                    // 裏面印刷
                    const hasBackContent = backData.templateImage ||
                      backData.logoImage ||
                      backData.logo2Image ||
                      Object.values(backData.formData).some(field => field.text && field.text.trim() !== '');
                    if (hasBackContent) {
                      const isBackMetallic = backData.printType === 'gold' || backData.printType === 'silver';
                      total += isBackMetallic ? 3000 : 2000;
                    }
                    return total.toLocaleString();
                  })()}
                </span>
              </div>
              <div className="price-shipping-info">送料無料</div>
              <button
                className="action-btn primary submit-btn-inline"
                onClick={handleCapture}
                disabled={isCapturing}
              >
                {isCapturing ? '画像生成中...' : 'この内容で依頼する'}
              </button>
            </div>
          </div>
        </div>

        {/* 右側: プレビュー */}
        <div className="designer-preview-panel">
          <div className="preview-header-row">
            <h3>
              プレビュー（{cardSide === 'front' ? '表面' : '裏面'}）
              <span className="drag-hint">ドラッグで配置変更</span>
            </h3>
            <div className="design-mode-toggle-mini">
              <button
                className={`mode-btn-mini ${designMode === 'free' ? 'active' : ''}`}
                onClick={() => setDesignMode('free')}
              >
                自由
              </button>
              <button
                className={`mode-btn-mini ${designMode === 'template' ? 'active' : ''}`}
                onClick={() => setDesignMode('template')}
              >
                テンプレ
              </button>
            </div>
            <button className="reset-btn-mini" onClick={handleReset}>
              リセット
            </button>
          </div>

          {/* プレビューズームスライダー */}
          <div className="preview-zoom-control">
            <label>ズーム: {Math.round(previewZoom)}%</label>
            <input
              type="range"
              min="50"
              max="300"
              value={previewZoom}
              onChange={(e) => setPreviewZoom(Number(e.target.value))}
            />
          </div>

          <div
            className="card-preview-container"
            ref={previewRef}
            style={{
              background: captureMode === 'print' ? '#ffffff' : (cardColor === 'white' ? '#1a1a2e' : '#4a4a5a'),
            }}
          >
            <div
              className="card-preview-wrapper"
              style={{
                width: `${cardWidth}px`,
                height: `${cardHeight}px`,
                transform: `scale(${previewZoom / 200})`,
                transformOrigin: 'center center',
                background: captureMode === 'print' ? '#ffffff' : (cardColor === 'white' ? '#ffffff' : '#1a1a1a'),
              }}
              onClick={() => setSelectedElement(null)}
            >
              {/* グリッドオーバーレイ */}
              {showGrid && !captureMode && (
                <div className="grid-overlay" />
              )}

              {/* 背景画像（金銀選択時はマスクで塗りつぶし） */}
              {templateImage && (
                <Draggable
                  key={`bg-drag-${printType}-${cardColor}`}
                  position={templatePosition}
                  onStop={handleTemplateDrag}
                  disabled={locks.template}
                >
                  <div
                    className={`preview-background-wrapper draggable-element ${locks.template ? 'locked' : ''} ${selectedElement === 'template' ? 'selected' : ''}`}
                    style={{
                      width: `${cardWidth * templateScale / 100}px`,
                      height: `${cardHeight * templateScale / 100}px`,
                      cursor: locks.template ? 'default' : 'move',
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedElement('template');
                    }}
                  >
                    {/* img要素でサイズを決定、マスク時はオーバーレイ */}
                    <img
                      src={templateImage}
                      alt="背景"
                      className="preview-background"
                      style={{
                        filter: needsMask ? 'brightness(0)' : getImageFilter(),
                        opacity: needsMask ? 0 : 1,
                      }}
                    />
                    {needsMask && (
                      <div
                        key={`bg-metallic-${printType}-${cardColor}-${metallicRenderKey}`}
                        className="preview-background metallic-masked-image"
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          WebkitMaskImage: `url(${templateImage})`,
                          maskImage: `url(${templateImage})`,
                          WebkitMaskSize: 'contain',
                          maskSize: 'contain',
                          WebkitMaskRepeat: 'no-repeat',
                          maskRepeat: 'no-repeat',
                          WebkitMaskPosition: 'top left',
                          maskPosition: 'top left',
                          background: getMetallicFill(),
                          width: '100%',
                          height: '100%',
                        }}
                      />
                    )}
                  </div>
                </Draggable>
              )}

              {/* アイコン1（金銀選択時はマスクで塗りつぶし） */}
              {logoImage && (
                <Draggable
                  key={`logo1-drag-${printType}-${cardColor}`}
                  position={logoPosition}
                  onStop={handleLogoDrag}
                  bounds="parent"
                  disabled={locks.logo}
                >
                  <div
                    className={`draggable-element logo-element ${locks.logo ? 'locked' : ''} ${selectedElement === 'logo' ? 'selected' : ''}`}
                    style={{
                      width: `${logoScale}px`,
                      height: 'auto',
                      cursor: locks.logo ? 'default' : 'move',
                      position: 'relative',
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedElement('logo');
                    }}
                  >
                    {/* img要素でサイズを決定、マスク時はオーバーレイ */}
                    <img
                      src={logoImage}
                      alt="アイコン1"
                      style={{
                        filter: needsMask ? 'brightness(0)' : getImageFilter(),
                        opacity: needsMask ? 0 : 1,
                        display: 'block',
                        width: '100%',
                        height: 'auto',
                      }}
                    />
                    {needsMask && (
                      <div
                        key={`logo1-metallic-${printType}-${cardColor}-${metallicRenderKey}`}
                        className="metallic-masked-image"
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          WebkitMaskImage: `url(${logoImage})`,
                          maskImage: `url(${logoImage})`,
                          WebkitMaskSize: 'contain',
                          maskSize: 'contain',
                          WebkitMaskRepeat: 'no-repeat',
                          maskRepeat: 'no-repeat',
                          WebkitMaskPosition: 'top left',
                          maskPosition: 'top left',
                          background: getMetallicFill(),
                        }}
                      />
                    )}
                  </div>
                </Draggable>
              )}

              {/* アイコン2（金銀選択時はマスクで塗りつぶし） */}
              {logo2Image && (
                <Draggable
                  key={`logo2-drag-${printType}-${cardColor}`}
                  position={logo2Position}
                  onStop={handleLogo2Drag}
                  bounds="parent"
                  disabled={locks.logo2}
                >
                  <div
                    className={`draggable-element logo-element ${locks.logo2 ? 'locked' : ''} ${selectedElement === 'logo2' ? 'selected' : ''}`}
                    style={{
                      width: `${logo2Scale}px`,
                      height: 'auto',
                      cursor: locks.logo2 ? 'default' : 'move',
                      position: 'relative',
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedElement('logo2');
                    }}
                  >
                    {/* img要素でサイズを決定、マスク時はオーバーレイ */}
                    <img
                      src={logo2Image}
                      alt="アイコン2"
                      style={{
                        filter: needsMask ? 'brightness(0)' : getImageFilter(),
                        opacity: needsMask ? 0 : 1,
                        display: 'block',
                        width: '100%',
                        height: 'auto',
                      }}
                    />
                    {needsMask && (
                      <div
                        key={`logo2-metallic-${printType}-${cardColor}-${metallicRenderKey}`}
                        className="metallic-masked-image"
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          WebkitMaskImage: `url(${logo2Image})`,
                          maskImage: `url(${logo2Image})`,
                          WebkitMaskSize: 'contain',
                          maskSize: 'contain',
                          WebkitMaskRepeat: 'no-repeat',
                          maskRepeat: 'no-repeat',
                          WebkitMaskPosition: 'top left',
                          maskPosition: 'top left',
                          background: getMetallicFill(),
                        }}
                      />
                    )}
                  </div>
                </Draggable>
              )}

              {/* テキスト要素 */}
              {Object.entries(formData).map(([field, data]) => {
                const displayText = getDisplayText(field);
                if (!displayText) return null;

                // 印刷タイプに応じたテキストスタイル
                const getTextStyle = () => {
                  const baseStyle = {
                    fontSize: `${data.fontSize}px`,
                    fontFamily: globalFont,
                  };

                  // 印刷モードでは常に黒文字
                  if (captureMode === 'print') {
                    return {
                      ...baseStyle,
                      color: '#000000',
                      background: 'none',
                      WebkitBackgroundClip: 'unset',
                      WebkitTextFillColor: '#000000',
                    };
                  }

                  if (printType === 'gold') {
                    return {
                      ...baseStyle,
                      background: 'linear-gradient(135deg, #bf953f 0%, #fcf6ba 25%, #b38728 50%, #fbf5b7 75%, #aa771c 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text',
                    };
                  } else if (printType === 'silver') {
                    return {
                      ...baseStyle,
                      background: 'linear-gradient(135deg, #707070 0%, #B0B0B0 25%, #808080 50%, #A8A8A8 75%, #606060 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text',
                    };
                  } else if (printType === 'white') {
                    // 黒カード用: 白印刷
                    return {
                      ...baseStyle,
                      color: '#ffffff',
                    };
                  } else {
                    // none: カラー印刷（白カード用）
                    return {
                      ...baseStyle,
                      color: data.color,
                    };
                  }
                };

                const isLocked = locks[field];

                return (
                  <Draggable
                    key={field}
                    position={textPositions[field]}
                    onStop={(e, d) => handleTextDrag(field, e, d)}
                    bounds="parent"
                    disabled={isLocked}
                  >
                    <div
                      className={`draggable-element text-element ${(printType === 'gold' || printType === 'silver') ? 'metallic-text' : ''} ${isLocked ? 'locked' : ''} ${data.vertical ? 'vertical-text' : ''} ${selectedElement === field ? 'selected' : ''}`}
                      style={{
                        ...getTextStyle(),
                        whiteSpace: (field === 'address' || field === 'freeText') ? 'pre-line' : 'nowrap',
                        cursor: isLocked ? 'default' : 'move',
                        ...(data.vertical && {
                          writingMode: 'vertical-rl',
                          textOrientation: 'upright',
                        }),
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedElement(field);
                      }}
                    >
                      {displayText}
                    </div>
                  </Draggable>
                );
              })}
            </div>
          </div>
          <div className="preview-controls-row">
            <div className="preview-controls-buttons">
              <button
                type="button"
                className={`control-btn grid-toggle ${showGrid ? 'active' : ''}`}
                onClick={() => setShowGrid(!showGrid)}
              >
                {showGrid ? '▦ OFF' : '▦ グリッド'}
              </button>
              <button
                type="button"
                className={`control-btn fine-adjust-toggle ${fineAdjustMode ? 'active' : ''}`}
                onClick={() => setFineAdjustMode(!fineAdjustMode)}
              >
                {fineAdjustMode ? '✕ 閉じる' : '🎮 微調整'}
              </button>
              <div className="side-toggle-inline">
                <button
                  className={`side-btn ${cardSide === 'front' ? 'active' : ''}`}
                  onClick={() => handleCardSideChange('front')}
                >
                  表面
                </button>
                <button
                  className={`side-btn ${cardSide === 'back' ? 'active' : ''}`}
                  onClick={() => handleCardSideChange('back')}
                >
                  裏面
                </button>
              </div>
            </div>
          </div>

          {/* 微調整モードパネル */}
          {fineAdjustMode && (
            <div className={`fine-adjust-panel ${selectedElement && locks[selectedElement] ? 'element-locked' : ''}`}>
              <div className="fine-adjust-header">
                <span>要素を選択して十字キーで移動</span>
                <button
                  type="button"
                  className="fine-adjust-close"
                  onClick={() => setFineAdjustMode(false)}
                >
                  ✕
                </button>
              </div>

              <div className="fine-adjust-content">
                {/* 要素選択 */}
                <div className="element-selector">
                  <label>編集する要素:</label>
                  <select
                    value={selectedElement || ''}
                    onChange={(e) => setSelectedElement(e.target.value || null)}
                  >
                    <option value="">-- 選択してください --</option>
                    {elementOptions.filter(opt => opt.hasContent).map(opt => (
                      <option key={opt.key} value={opt.key}>{opt.label}</option>
                    ))}
                  </select>
                </div>

                {/* コントロール一列配置 */}
                <div className="fine-adjust-controls-row">
                  {/* D-Pad (十字キー) */}
                  <div className="dpad">
                    <button type="button" className="dpad-btn dpad-up" onClick={() => handleFineAdjust('up')} disabled={!selectedElement || locks[selectedElement]}>▲</button>
                    <button type="button" className="dpad-btn dpad-left" onClick={() => handleFineAdjust('left')} disabled={!selectedElement || locks[selectedElement]}>◀</button>
                    <div className="dpad-center"></div>
                    <button type="button" className="dpad-btn dpad-right" onClick={() => handleFineAdjust('right')} disabled={!selectedElement || locks[selectedElement]}>▶</button>
                    <button type="button" className="dpad-btn dpad-down" onClick={() => handleFineAdjust('down')} disabled={!selectedElement || locks[selectedElement]}>▼</button>
                  </div>

                  {/* 移動幅 */}
                  <div className="step-slider-compact">
                    <label>移動幅</label>
                    <span>{adjustStep}px</span>
                    <input type="range" min="1" max="200" value={adjustStep} onChange={(e) => setAdjustStep(Number(e.target.value))} />
                  </div>

                  {/* 選択中要素と追加コントロール */}
                  {selectedElement && (
                    <>
                      {/* テキスト: 色 */}
                      {!['template', 'logo', 'logo2'].includes(selectedElement) && formData[selectedElement] && (
                        <input
                          type="color"
                          value={formData[selectedElement]?.color || '#000000'}
                          onChange={(e) => handleInputChange(selectedElement, 'color', e.target.value)}
                          className="color-input-mini"
                          disabled={locks[selectedElement]}
                        />
                      )}

                      {/* サイズ調整 */}
                      <div className="size-slider-compact">
                        <label>大きさ</label>
                        {!['template', 'logo', 'logo2'].includes(selectedElement) && formData[selectedElement] && (
                          <>
                            <span>{formData[selectedElement]?.fontSize}px</span>
                            <input
                              type="range"
                              min="6"
                              max="200"
                              value={formData[selectedElement]?.fontSize || 12}
                              onChange={(e) => handleInputChange(selectedElement, 'fontSize', Number(e.target.value))}
                              disabled={locks[selectedElement]}
                            />
                          </>
                        )}
                        {selectedElement === 'logo' && logoImage && (
                          <>
                            <span>{logoScale}%</span>
                            <input
                              type="range"
                              min="10"
                              max="200"
                              value={logoScale}
                              onChange={(e) => handleScaleChange('logo', Number(e.target.value))}
                              disabled={locks[selectedElement]}
                            />
                          </>
                        )}
                        {selectedElement === 'logo2' && logo2Image && (
                          <>
                            <span>{logo2Scale}%</span>
                            <input
                              type="range"
                              min="10"
                              max="200"
                              value={logo2Scale}
                              onChange={(e) => handleScaleChange('logo2', Number(e.target.value))}
                              disabled={locks[selectedElement]}
                            />
                          </>
                        )}
                        {selectedElement === 'template' && templateImage && (
                          <>
                            <span>{templateScale}%</span>
                            <input
                              type="range"
                              min="10"
                              max="300"
                              value={templateScale}
                              onChange={(e) => handleScaleChange('template', Number(e.target.value))}
                              disabled={locks[selectedElement]}
                            />
                          </>
                        )}
                      </div>

                      {/* ロック */}
                      <button
                        type="button"
                        className={`lock-btn-mini ${locks[selectedElement] ? 'locked' : ''}`}
                        onClick={() => toggleLock(selectedElement)}
                        title={locks[selectedElement] ? 'クリックでロック解除' : 'クリックでロック'}
                      >
                        {locks[selectedElement] ? '🔒 ロック中' : '🔓'}
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* キャプチャ結果モーダル */}
      {showCaptureModal && capturedImages && (
        <div className="capture-modal-overlay" onClick={() => !isSubmitting && setShowCaptureModal(false)}>
          <div className="capture-modal" onClick={(e) => e.stopPropagation()}>
            <h2>デザイン確認・送信</h2>
            <p className="capture-modal-description">
              デザイン内容をご確認ください
            </p>
            <ul className="capture-modal-notes">
              <li>実際の印刷と色味や見え方が異なる場合がございます。</li>
              <li>提出後担当者からの折り返しのメールが来てから最終的なご注文の確定となります。</li>
              <li>この画面でのプレビューを画像として保存していただけます。</li>
            </ul>

            {/* 表面/裏面 切り替えタブ */}
            {capturedImages.back.preview && (
              <div className="modal-side-tabs">
                <button
                  className={`modal-side-tab ${modalPreviewSide === 'front' ? 'active' : ''}`}
                  onClick={() => setModalPreviewSide('front')}
                >
                  表面
                </button>
                <button
                  className={`modal-side-tab ${modalPreviewSide === 'back' ? 'active' : ''}`}
                  onClick={() => setModalPreviewSide('back')}
                >
                  裏面
                </button>
              </div>
            )}

            <div className="capture-images-grid">
              <div className="capture-section">
                {!capturedImages.back.preview && <h3>表面</h3>}
                <div className="capture-image-single">
                  <img
                    src={modalPreviewSide === 'front' ? capturedImages.front.preview : capturedImages.back.preview}
                    alt={modalPreviewSide === 'front' ? '表面' : '裏面'}
                  />
                </div>
              </div>
            </div>

            <div className="capture-modal-price">
              <span>合計金額:</span>
              <span className="price-value">¥{calculateTotalPrice().toLocaleString()}<span className="price-tax">（税込）</span></span>
              <span className="price-shipping">送料無料</span>
            </div>

            {/* お客様情報入力 */}
            <div className="customer-info-section">
              <h3>お客様情報</h3>
              <div className="customer-input-group">
                <label>
                  <span>お名前 <span className="required">*</span></span>
                  <input
                    type="text"
                    value={customerName}
                    onChange={(e) => setCustomerName(e.target.value)}
                    placeholder="手裏剣 太郎"
                    disabled={isSubmitting}
                  />
                </label>
                <label>
                  <span>メールアドレス <span className="required">*</span></span>
                  <input
                    type="email"
                    value={customerEmail}
                    onChange={(e) => setCustomerEmail(e.target.value)}
                    placeholder="example@email.com"
                    disabled={isSubmitting}
                  />
                </label>
              </div>
            </div>

            <div className="capture-modal-actions">
              <button
                className="capture-btn primary"
                onClick={() => setShowOrderConfirm(true)}
                disabled={isSubmitting}
              >
                {isSubmitting ? '送信中...' : 'この内容で注文する'}
              </button>
              <button
                className="capture-btn secondary"
                onClick={() => setShowCaptureModal(false)}
                disabled={isSubmitting}
              >
                戻って編集する
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 注文確認ポップアップ */}
      {showOrderConfirm && (
        <div className="order-confirm-overlay" onClick={() => !isSubmitting && setShowOrderConfirm(false)}>
          <div className="order-confirm-modal" onClick={(e) => e.stopPropagation()}>
            <p className="order-confirm-message">提出します。よろしいですか？</p>
            <div className="order-confirm-buttons">
              <button
                className="order-confirm-btn yes"
                onClick={() => {
                  setShowOrderConfirm(false);
                  handleSubmitToGAS();
                }}
                disabled={isSubmitting}
              >
                はい
              </button>
              <button
                className="order-confirm-btn no"
                onClick={() => setShowOrderConfirm(false)}
                disabled={isSubmitting}
              >
                いいえ
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 送信完了モーダル */}
      {showSuccessModal && (
        <div className="success-modal-overlay" onClick={() => setShowSuccessModal(false)}>
          <div className="success-modal" onClick={(e) => e.stopPropagation()}>
            <div className="success-modal-header">
              <span className="success-modal-title">shuriken</span>
            </div>
            <div className="success-modal-body">
              <p>shurikenをご注文いただき誠にありがとうございます。</p>
              <p>ご依頼いただきましたデータの確認を行い、印刷の可否とお支払いについてのご案内を担当者よりメールにてご案内いたします。</p>
              <p>今暫くお待ち下さい。</p>
            </div>
            <button className="success-modal-btn" onClick={() => setShowSuccessModal(false)}>
              OK
            </button>
          </div>
        </div>
      )}

      {/* キャプチャ中のオーバーレイ */}
      {isCapturing && (
        <div className="capture-loading-overlay">
          <div className="capture-loading-content">
            <img src={shurikenLogo} alt="" className="capture-loading-logo" />
            <p>画像を生成しています...</p>
          </div>
        </div>
      )}

      {/* ページ読み込み中のオーバーレイ */}
      {isPageLoading && (
        <div className="page-loading-overlay">
          <div className="page-loading-content">
            <img src={shurikenLogo} alt="Loading" className="page-loading-logo" />
            <p>読み込み中...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShurikenDesigner;
